(function () {
  "use strict";

  /* ===================== demo customer "Alex" (?demo=1) ===================== */
  var DEMO_NAME = "Alex";
  var DEMO_DATA = {
    blood: {
      publishedAt: "2026-06-26T09:00:00Z",
      retestWeeks: 12,
      counts: { inRange: 40, attention: 13, total: 53 },
      date: "2026-06-26",
      /* full 53-marker demo panel: 13 flagged + 40 in range, consistent with counts */
      findings: [
        /* -- flagged (13) -- */
        { marker: "LDL Cholesterol", value: 152, unit: "mg/dL", range: "<130", flag: "high", category: "Cholesterol Profile" },
        { marker: "ApoB", value: 112, unit: "mg/dL", range: "<90", flag: "high", category: "Cholesterol Profile" },
        { marker: "Triglycerides", value: 168, unit: "mg/dL", range: "<150", flag: "high", category: "Cholesterol Profile" },
        { marker: "Total Cholesterol", value: 224, unit: "mg/dL", range: "<200", flag: "high", category: "Cholesterol Profile" },
        { marker: "hs-CRP", value: 2.4, unit: "mg/L", range: "<1.0", flag: "borderline", category: "Inflammation" },
        { marker: "Homocysteine", value: 13.8, unit: "umol/L", range: "<10.4", flag: "high", category: "Inflammation" },
        { marker: "Vitamin D", value: 24.6, unit: "ng/mL", range: "30-100", flag: "low", category: "Vitamins & Minerals" },
        { marker: "Vitamin B12", value: 285, unit: "pg/mL", range: "300-900", flag: "low-normal", category: "Vitamins & Minerals" },
        { marker: "Folate", value: 4.1, unit: "ng/mL", range: "4-20", flag: "low-normal", category: "Vitamins & Minerals" },
        { marker: "Total Testosterone", value: 296, unit: "ng/dL", range: "300-900", flag: "low-normal", category: "Hormones" },
        { marker: "Fasting Insulin", value: 11.8, unit: "uIU/mL", range: "2-10", flag: "borderline", category: "Blood Sugar" },
        { marker: "Ferritin", value: 38, unit: "ng/mL", range: "50-300", flag: "low-normal", category: "Iron" },
        { marker: "Uric Acid", value: 7.6, unit: "mg/dL", range: "3.5-7.2", flag: "borderline", category: "Kidney" },
        /* -- in range (40) -- */
        { marker: "HDL Cholesterol", value: 52, unit: "mg/dL", range: ">40", flag: "normal", category: "Cholesterol Profile" },
        { marker: "Lp(a)", value: 18, unit: "nmol/L", range: "<75", flag: "normal", category: "Cholesterol Profile" },
        { marker: "HbA1c", value: 5.4, unit: "%", range: "<5.7", flag: "normal", category: "Blood Sugar" },
        { marker: "Fasting Glucose", value: 88, unit: "mg/dL", range: "70-99", flag: "normal", category: "Blood Sugar" },
        { marker: "ALT", value: 28, unit: "U/L", range: "<44", flag: "normal", category: "Liver" },
        { marker: "AST", value: 24, unit: "U/L", range: "<40", flag: "normal", category: "Liver" },
        { marker: "GGT", value: 22, unit: "U/L", range: "<60", flag: "normal", category: "Liver" },
        { marker: "Alkaline Phosphatase", value: 68, unit: "U/L", range: "40-130", flag: "normal", category: "Liver" },
        { marker: "Albumin", value: 4.5, unit: "g/dL", range: "3.5-5.2", flag: "normal", category: "Liver" },
        { marker: "Total Bilirubin", value: 0.7, unit: "mg/dL", range: "<1.2", flag: "normal", category: "Liver" },
        { marker: "Total Protein", value: 7.1, unit: "g/dL", range: "6.0-8.3", flag: "normal", category: "Liver" },
        { marker: "Creatinine", value: 0.98, unit: "mg/dL", range: "0.7-1.3", flag: "normal", category: "Kidney" },
        { marker: "eGFR", value: 96, unit: "mL/min", range: ">90", flag: "normal", category: "Kidney" },
        { marker: "BUN", value: 15, unit: "mg/dL", range: "7-20", flag: "normal", category: "Kidney" },
        { marker: "TSH", value: 1.8, unit: "mIU/L", range: "0.4-4.0", flag: "normal", category: "Thyroid" },
        { marker: "Free T4", value: 1.3, unit: "ng/dL", range: "0.8-1.8", flag: "normal", category: "Thyroid" },
        { marker: "Free T3", value: 3.2, unit: "pg/mL", range: "2.3-4.2", flag: "normal", category: "Thyroid" },
        { marker: "Free Testosterone", value: 9.8, unit: "pg/mL", range: "9-27", flag: "normal", category: "Hormones" },
        { marker: "SHBG", value: 34, unit: "nmol/L", range: "16-55", flag: "normal", category: "Hormones" },
        { marker: "DHEA-S", value: 285, unit: "ug/dL", range: "138-475", flag: "normal", category: "Hormones" },
        { marker: "Morning Cortisol", value: 14.2, unit: "ug/dL", range: "6-18", flag: "normal", category: "Hormones" },
        { marker: "Estradiol", value: 24, unit: "pg/mL", range: "10-40", flag: "normal", category: "Hormones" },
        { marker: "Magnesium", value: 2.1, unit: "mg/dL", range: "1.7-2.2", flag: "normal", category: "Vitamins & Minerals" },
        { marker: "Zinc", value: 92, unit: "ug/dL", range: "70-120", flag: "normal", category: "Vitamins & Minerals" },
        { marker: "Calcium", value: 9.4, unit: "mg/dL", range: "8.5-10.2", flag: "normal", category: "Vitamins & Minerals" },
        { marker: "Sodium", value: 140, unit: "mmol/L", range: "135-145", flag: "normal", category: "Vitamins & Minerals" },
        { marker: "Potassium", value: 4.3, unit: "mmol/L", range: "3.5-5.1", flag: "normal", category: "Vitamins & Minerals" },
        { marker: "Iron", value: 88, unit: "ug/dL", range: "60-170", flag: "normal", category: "Iron" },
        { marker: "TIBC", value: 320, unit: "ug/dL", range: "250-450", flag: "normal", category: "Iron" },
        { marker: "Transferrin Saturation", value: 28, unit: "%", range: "20-50", flag: "normal", category: "Iron" },
        { marker: "WBC", value: 5.8, unit: "K/uL", range: "4.0-11.0", flag: "normal", category: "Blood Count" },
        { marker: "RBC", value: 5.1, unit: "M/uL", range: "4.5-5.9", flag: "normal", category: "Blood Count" },
        { marker: "Hemoglobin", value: 15.2, unit: "g/dL", range: "13.5-17.5", flag: "normal", category: "Blood Count" },
        { marker: "Hematocrit", value: 45.1, unit: "%", range: "41-53", flag: "normal", category: "Blood Count" },
        { marker: "MCV", value: 89, unit: "fL", range: "80-100", flag: "normal", category: "Blood Count" },
        { marker: "MCH", value: 29.8, unit: "pg", range: "27-33", flag: "normal", category: "Blood Count" },
        { marker: "MCHC", value: 33.4, unit: "g/dL", range: "32-36", flag: "normal", category: "Blood Count" },
        { marker: "Platelets", value: 242, unit: "K/uL", range: "150-400", flag: "normal", category: "Blood Count" },
        { marker: "Neutrophils", value: 55, unit: "%", range: "40-70", flag: "normal", category: "Blood Count" },
        { marker: "Lymphocytes", value: 34, unit: "%", range: "20-45", flag: "normal", category: "Blood Count" }
      ]
    },
    dexa: { date: "2026-08-02", prevDate: "2026-03-12", prevBodyFat: 18.8, bodyFat: 18.2, leanMass: "62.4 kg", boneZ: 0.8, counts: { inRange: 5, attention: 1 } },
    gut: { date: "2026-08-05", score: 78, counts: { inRange: 4, attention: 1 } },
    dna: { date: "2026-07-18", traits: 24, variantsAnalyzed: 84,
      traitList: [
        { trait: "Lactose tolerance", category: "Nutrition", genotype: "CC at rs4988235", effect: "likely intolerant", percentile: 18 },
        { trait: "Caffeine metabolism", category: "Nutrition", genotype: "AC at rs762551", effect: "slow metabolizer", percentile: 34 },
        { trait: "Vitamin D need", category: "Nutrition", genotype: "GT at rs2282679", effect: "higher need", percentile: 22 },
        { trait: "Omega-3 conversion", category: "Nutrition", genotype: "TT at rs174537", effect: "reduced conversion", percentile: 28 },
        { trait: "Folate processing", category: "Nutrition", genotype: "CT at rs1801133", effect: "slightly reduced", percentile: 41 },
        { trait: "Saturated fat sensitivity", category: "Nutrition", genotype: "CC at rs5082", effect: "typical", percentile: 52 },
        { trait: "Salt sensitivity", category: "Nutrition", genotype: "GA at rs4343", effect: "slightly increased", percentile: 44 },
        { trait: "Power vs endurance", category: "Fitness", genotype: "RX at rs1815739", effect: "mixed profile", percentile: 55 },
        { trait: "Muscle recovery speed", category: "Fitness", genotype: "GG at rs1049434", effect: "average recovery", percentile: 50 },
        { trait: "Injury susceptibility", category: "Fitness", genotype: "CT at rs12722", effect: "slightly raised", percentile: 38 },
        { trait: "VO2max trainability", category: "Fitness", genotype: "AG at rs8192678", effect: "good responder", percentile: 68 },
        { trait: "Grip strength potential", category: "Fitness", genotype: "AA at rs752045", effect: "typical", percentile: 57 },
        { trait: "Chronotype", category: "Sleep", genotype: "AG at rs1801260", effect: "mild night owl", percentile: 61 },
        { trait: "Sleep depth", category: "Sleep", genotype: "CC at rs73598374", effect: "typical", percentile: 49 },
        { trait: "Caffeine sleep impact", category: "Sleep", genotype: "AC at rs762551", effect: "strong evening impact", percentile: 30 },
        { trait: "Restless sleep tendency", category: "Sleep", genotype: "GT at rs3923809", effect: "slightly raised", percentile: 42 },
        { trait: "Stress resilience", category: "Mood", genotype: "GA at rs4680", effect: "balanced", percentile: 54 },
        { trait: "Serotonin transport", category: "Mood", genotype: "LS at 5-HTTLPR", effect: "intermediate", percentile: 47 },
        { trait: "Dopamine clearance", category: "Mood", genotype: "AA at rs4680", effect: "slower clearance", percentile: 36 },
        { trait: "Anxiety tendency", category: "Mood", genotype: "CT at rs6295", effect: "typical", percentile: 51 },
        { trait: "Cellular aging pace", category: "Longevity", genotype: "TC at rs2736100", effect: "average telomere", percentile: 53 },
        { trait: "Inflammation baseline", category: "Longevity", genotype: "GC at rs1800795", effect: "slightly raised", percentile: 40 },
        { trait: "Lipid handling", category: "Longevity", genotype: "E3/E4 at APOE", effect: "one E4 copy", percentile: 25 },
        { trait: "Blood sugar control", category: "Longevity", genotype: "CT at rs7903146", effect: "typical", percentile: 56 }
      ] },
    cortisol: { date: "2026-08-08", car: "+48%", counts: { inRange: 3, attention: 1 },
      findings: [
        /* 48% is the waking RISE, and the expected window is 50 to 160%, so this
           sits just under it. It is flagged low, never high: the report engine,
           this tile and the projection all have to tell the same story.
           One cortisol range only. The routine targets and the projection print
           the same 50 to 160% window this finding carries, so a reader never
           meets a narrower personal target printed beside a wider reference one. */
        { marker: "Waking cortisol", value: "+48%", unit: "%", range: "50-160%", flag: "low" },
        { marker: "Midday cortisol", value: "", flag: "normal" },
        { marker: "Evening cortisol", value: "", flag: "normal" },
        { marker: "Night cortisol", value: "", flag: "normal" }
      ] },
    bioage: { date: "2026-08-02", prevDate: "2026-03-12", prevBioAge: 41.8, bioAge: 41.2, chronoAge: 45, pace: 0.96, counts: { inRange: 1, attention: 0 } },
    omega3: { date: "2026-08-05", prevDate: "2026-03-12", prevIndex: 5.4, index: 6.1, note: "a little below optimal", counts: { inRange: 0, attention: 1 } },
    female: null,
    cac: { date: "2026-07-25", score: 0, label: "the power of zero", arterialAge: 39, counts: { inRange: 1, attention: 0 } },
    vo2max: { date: "2026-08-15", prevDate: "2026-03-12", prevVo2max: 43.7, vo2max: 44.9, fitnessAge: 38, counts: { inRange: 1, attention: 0 } },
    quizGoals: ["Energy", "Fitness"],
    quizIntake: { gender: "male", lifestyle: "active", sleepHours: 7.4 },
    ai: {
      version: 1,
      generatedAt: "2026-08-12T09:00:00Z",
      reviewedBy: "Dr Mansour",
      overallAssessment: "Your heart numbers moved the most since your last test, and your nutrient levels slipped a little. That's where this cycle's plan goes. None of it is urgent. Every number below comes with something you can do about it this week.",
      overallTrend: 4,
      systemScores: [
        { system: "Heart", score: 78, label: "Fair", trend: 6, drivers: ["LDL 152", "ApoB 112", "Omega-3 Index 6.1%", "VO2max 44.9"], lenses: ["blood", "omega3", "cac", "vo2max"] },
        { system: "Metabolic", score: 93, label: "Optimal", trend: 1, drivers: ["HbA1c 5.4%", "Fasting glucose 88"], lenses: ["blood"] },
        { system: "Hormones", score: 72, label: "Fair", trend: 3, drivers: ["Total testosterone 296", "Waking cortisol +48%"], lenses: ["blood", "cortisol"] },
        { system: "Nutrients", score: 64, label: "Pay attention", trend: -2, drivers: ["Vitamin D 24.6", "Vitamin B12 285"], lenses: ["blood"] },
        { system: "Body", score: 88, label: "Strong", trend: 2, drivers: ["Body fat 18.2%", "Bone Z-score +0.8"], lenses: ["dexa"] }
      ],
      combinations: [
        {
          title: "Three tests say the same thing about your heart",
          lenses: ["blood", "cac", "omega3"],
          narrative: "Your LDL is 152 and your omega-3 index is 6.1%, and both pull the same way. Your calcium score is zero though, so there's no plaque to undo yet. That's a good place to be starting from.",
          severity: "attention",
          systems: ["Heart"],
          markers: [
            { name: "LDL", value: 152, unit: "mg/dL", target: "<130", delta: 9 },
            { name: "ApoB", value: 112, unit: "mg/dL", target: "<90", delta: 6 },
            { name: "Omega-3 Index", value: 6.1, unit: "%", target: ">8" },
            { name: "Calcium score", value: 0, unit: "", target: "0" }
          ]
        },
        {
          title: "Your cortisol and your testosterone are linked",
          lenses: ["cortisol", "blood"],
          narrative: "Your cortisol rises 48% on waking, a little under the 50 to 160% we expect, and your testosterone is 296 against a floor of 300. Together that usually means you're under-recovered, not that anything is wrong with a gland. The wind-down stack is built for exactly this.",
          severity: "attention",
          systems: ["Hormones", "Recovery"],
          markers: [
            { name: "Waking cortisol", value: "+48", unit: "%", target: "+50-160%" },
            { name: "Testosterone", value: 296, unit: "ng/dL", target: "300-900", delta: -14 }
          ]
        },
        {
          title: "Vitamin D and B12 explain the energy dip",
          lenses: ["blood", "dna"],
          narrative: "Your vitamin D is 24.6 and healthy starts at 30. Your B12 is 285 against a floor of 300. Your DNA says you need more vitamin D than most people do, which fits. Of everything on this page, this is the easiest to fix.",
          severity: "attention",
          systems: ["Nutrients"],
          markers: [
            { name: "Vitamin D", value: 24.6, unit: "ng/mL", target: "30-100", delta: -2.1 },
            { name: "Vitamin B12", value: 285, unit: "pg/mL", target: "300-900" },
            { name: "Folate", value: 4.1, unit: "ng/mL", target: "4-20" }
          ]
        },
        {
          title: "Iron stores are quietly low",
          lenses: ["blood"],
          narrative: "Ferritin is usually the first iron marker to slip, and yours is 38 against a floor of 50. The rest of your iron panel is fine. Worth fixing now, before you feel it in your energy or your training.",
          severity: "attention",
          systems: ["Nutrients"],
          markers: [
            { name: "Ferritin", value: 38, unit: "ng/mL", target: "50-300" },
            { name: "Iron", value: 88, unit: "ug/dL", target: "60-170" }
          ]
        },
        {
          title: "Your engine room is strong",
          lenses: ["blood", "dexa"],
          narrative: "Your blood sugar and your body composition are both in good shape. That gives everything else you change a steady base to work from.",
          severity: "ok",
          systems: ["Metabolic", "Body"],
          markers: [
            { name: "HbA1c", value: 5.4, unit: "%", target: "<5.7" },
            { name: "Body fat", value: 18.2, unit: "%", target: "14-20", delta: -0.6 }
          ]
        },
        {
          title: "Fitness is buying you years",
          lenses: ["vo2max", "bioage"],
          narrative: "A VO2max of 44.9 puts your fitness age at 38, and your epigenetic clock agrees you're aging slower than the calendar. Whatever training got you here, keep doing it.",
          severity: "ok",
          systems: ["Heart", "Body"],
          markers: [
            { name: "VO2max", value: 44.9, unit: "ml/kg/min", target: ">43", delta: 1.2 },
            { name: "BioAge", value: 41.2, unit: "yrs", target: "under 45" }
          ]
        }
      ],
      routine: {
        goals: ["energy", "heart"],
        stacks: [
          { id: "morning", title: "Morning Stack", tagline: "Sets the day", actions: [
            { id: "a1", title: "Berberine with breakfast", frequency: "daily", source: "physician",
              why: "Helps bring your LDL and ApoB down, which is what this plan is built around.",
              steps: ["Take 500 mg with the first bite of breakfast", "Pair with your largest carb meal on training days", "Note any digestive change in week one"],
              improves: [{ marker: "LDL", current: 152, target: "<130" }, { marker: "ApoB", current: 112, target: "<90" }], status: "proposed" },
            { id: "a2", title: "Vitamin D 5000 IU", frequency: "daily", source: "physician",
              why: "Should get your vitamin D over 30 within one cycle.",
              steps: ["Take with a meal that contains fat", "Same time daily so it becomes automatic", "Retest confirms the dose in 12 weeks"],
              improves: [{ marker: "Vitamin D", current: 24.6, target: ">30" }], status: "proposed" },
            { id: "a3", title: "Omega-3, 2 g with food", frequency: "daily", source: "physician",
              why: "Moves your omega-3 index up toward 8%.",
              steps: ["2 g EPA+DHA combined, label-checked", "Take with your fattiest meal for absorption"],
              improves: [{ marker: "Omega-3 Index", current: "6.1%", target: ">8%" }], status: "proposed" }
          ]},
          { id: "plate", title: "The Plate", tagline: "Most leverage per meal", actions: [
            { id: "a4", title: "Protein anchor at every meal", frequency: "daily", source: "ai",
              why: "Keeps the lean mass your DEXA found while everything else changes.",
              improves: [{ marker: "Lean mass", current: "62.4 kg", target: "maintain" }], status: "proposed" },
            { id: "a5", title: "Two fist-size vegetable servings", frequency: "daily", source: "ai",
              why: "Soluble fiber brings LDL down, quietly, without much effort from you.",
              improves: [{ marker: "LDL", current: 152, target: "<130" }], status: "proposed" },
            { id: "a6", title: "Cap alcohol at two evenings", frequency: "weekly", source: "ai",
              why: "Your triglycerides respond to this faster than to almost anything else.",
              improves: [{ marker: "Triglycerides", current: 168, target: "<150" }], status: "proposed" }
          ]},
          { id: "activity", title: "Activity", tagline: "Built around your week", actions: [
            { id: "a7", title: "Resistance training, three sessions", frequency: "weekly", source: "ai",
              why: "Nothing natural moves testosterone as reliably as lifting does.",
              steps: ["Three full-body sessions, 45 minutes each", "Push the big lifts close to effort", "Keep one full rest day between sessions"],
              improves: [{ marker: "Testosterone", current: 296, target: ">350" }], status: "proposed" },
            { id: "a8", title: "Ten-minute walk after your largest meal", frequency: "daily", source: "ai",
              why: "Takes the edge off the triglyceride spike from that meal.",
              improves: [{ marker: "Triglycerides", current: 168, target: "<150" }], status: "proposed" }
          ]},
          { id: "winddown", title: "Wind-down", tagline: "Sleep is the hardest worker", actions: [
            { id: "a9", title: "Screens off by 22:30", frequency: "daily", source: "ai",
              why: "Late screens keep your cortisol up. Switch them off and it settles overnight.",
              steps: ["Charge the phone outside the bedroom", "Swap the last half hour for paper or audio"],
              improves: [{ marker: "Waking cortisol", current: "+48%", target: "+50-160%" }], status: "proposed" },
            { id: "a10", title: "Magnesium glycinate before bed", frequency: "daily", source: "physician",
              why: "Deeper sleep, which everything above depends on.",
              improves: [{ marker: "Waking cortisol", current: "+48%", target: "+50-160%" }], status: "proposed" },
            { id: "a11", title: "Same wake time, every day", frequency: "daily", source: "ai",
              why: "Nothing sets your body clock like waking at the same time.",
              improves: [{ marker: "Waking cortisol", current: "+48%", target: "+50-160%" }], status: "proposed" }
          ]}
        ]
      },
      futureOutlook: {
        byDate: "November",
        expected: [
          { marker: "LDL", from: 152, toRange: "128-140" },
          { marker: "Vitamin D", from: 24.6, toRange: "32-40" },
          { marker: "Omega-3 Index", from: "6.1%", toRange: "7.5-8.5%" },
          { marker: "Triglycerides", from: 168, toRange: "135-150" },
          { marker: "Waking cortisol", from: "+48%", toRange: "+50-160%" }
        ]
      }
    }
  };

  /* ===================== helpers ===================== */
  var MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function parseDate(s) {
    if (!s) return null;
    var d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }
  function fmtD(d) { return d.getDate() + " " + MONTHS[d.getMonth()]; }
  function isArr(x) { return Object.prototype.toString.call(x) === "[object Array]"; }
  /* House copy convention: a small number in a sentence is a word, not a digit.
     A number that is a measurement stays a figure. */
  var NUMWORDS = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"];
  function numWord(n) { return (n >= 0 && n <= 10) ? NUMWORDS[n] : String(n); }
  function cap(s) { return String(s).charAt(0).toUpperCase() + String(s).slice(1); }

  /* ===================== drawn glyphs =====================
     Fourteen is the full set in the direction document; this file needs five.
     One 24 x 24 grid, 20 x 20 live area, 1.5px stroke at 24 scaled with size,
     round cap and round join, outline only, currentColor. They replace the
     text arrows and chevrons that used to be set in the body font at whatever
     size happened to fit the line. */
  function icon(name, size) {
    var s = size || 16;
    var sw = Math.round((1.5 * s / 24) * 100) / 100;
    var d = {
      "chevron-right": "M9.5 5.5 L16 12 L9.5 18.5",
      "chevron-down": "M5.5 9.5 L12 16 L18.5 9.5",
      "arrow-up-right": "M6 18 L18 6 M18 6 H10.5 M18 6 v7.5",
      check: "M5 12.5 L9.75 17.25 L19 8",
      close: "M6 6 L18 18 M18 6 L6 18"
    }[name];
    if (!d) return "";
    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="' + sw +
      '" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  /* same status mapping as wellness-results-v2 */
  function statusOf(flag) {
    var f = String(flag || "").toLowerCase();
    if (!f) return "ok";
    if (f.indexOf("low-normal") > -1 || f.indexOf("low normal") > -1) return "warn";
    if (f.indexOf("non-diabetic") > -1 || f.indexOf("non diabetic") > -1) return "ok";
    if (f.indexOf("borderline") > -1) return "warn";
    if (f.indexOf("high") > -1) return "bad";
    if (f.indexOf("low") > -1 || f.indexOf("insufficien") > -1) return "warn";
    if (f.indexOf("normal") > -1) return "ok";
    return "ok";
  }

  /* Tolerant per-lens counts: explicit counts, else derive (blood findings), else null. */
  function lensCounts(key, data) {
    if (!data || typeof data !== "object") return null;
    var c = data.counts;
    if (c && typeof c.inRange === "number") {
      return { inRange: c.inRange, attention: (typeof c.attention === "number" ? c.attention : 0), total: (typeof c.total === "number" ? c.total : c.inRange + (c.attention || 0)) };
    }
    if (typeof data.inRange === "number") {
      return { inRange: data.inRange, attention: (typeof data.attention === "number" ? data.attention : 0), total: data.inRange + (data.attention || 0) };
    }
    if (key === "blood" && isArr(data.findings)) {
      var ok = 0, at = 0;
      data.findings.forEach(function (f) {
        if (statusOf(f && f.flag) === "ok") ok++; else at++;
      });
      return { inRange: ok, attention: at, total: ok + at };
    }
    return null;
  }

  function lensDate(key, data) {
    if (!data || typeof data !== "object") return null;
    if (key === "blood") {
      var tl = data.timeline || {};
      return parseDate(tl.published) || parseDate(data.publishedAt) || parseDate(data.date);
    }
    return parseDate(data.date) || parseDate(data.publishedAt);
  }

  function isProcessing(data) {
    return !!(data && typeof data === "object" && String(data.status || "").toLowerCase() === "processing");
  }

  /* ===================== glyphs (add-state tiles) ===================== */
  var GLYPHS = {
    blood: '<svg width="40" height="54" viewBox="0 0 24 32"><path d="M12 2 C12 8 4 14 4 21 a8 8 0 0 0 16 0 C20 14 12 8 12 2z" fill="none" stroke="#A9A290" stroke-width="1.8" stroke-linejoin="round"/><path d="M8.5 21.5 a3.5 3.5 0 0 0 3.5 3.5" fill="none" stroke="#A9A290" stroke-width="1.6" stroke-linecap="round"/></svg>',
    dexa: '<svg width="40" height="58" viewBox="0 0 120 170"><circle cx="60" cy="16" r="11" fill="none" stroke="#A9A290" stroke-width="5"/><path d="M42 32 h36 q6 0 6 8 l-3 30 h-42 l-3 -30 q0 -8 6 -8z" fill="none" stroke="#A9A290" stroke-width="5"/><rect x="22" y="34" width="13" height="46" rx="6.5" fill="none" stroke="#A9A290" stroke-width="5"/><rect x="85" y="34" width="13" height="46" rx="6.5" fill="none" stroke="#A9A290" stroke-width="5"/><rect x="42" y="92" width="15" height="56" rx="7.5" fill="none" stroke="#A9A290" stroke-width="5"/><rect x="63" y="92" width="15" height="56" rx="7.5" fill="none" stroke="#A9A290" stroke-width="5"/></svg>',
    gut: '<svg width="56" height="44" viewBox="0 0 80 60"><circle cx="22" cy="22" r="10" fill="none" stroke="#A9A290" stroke-width="2"/><circle cx="47" cy="14" r="7" fill="none" stroke="#A9A290" stroke-width="2"/><circle cx="60" cy="34" r="12" fill="none" stroke="#A9A290" stroke-width="2"/><circle cx="30" cy="44" r="8" fill="none" stroke="#A9A290" stroke-width="2"/><circle cx="47" cy="50" r="5" fill="none" stroke="#A9A290" stroke-width="2"/></svg>',
    dna: '<svg width="40" height="56" viewBox="0 0 24 34"><path d="M7 2c0 8 10 7 10 15S7 22 7 32M17 2c0 8-10 7-10 15s10 7 10 15M8.5 6.5h7M8.5 27.5h7M8 17h8" stroke="#A9A290" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>',
    cortisol: '<svg width="66" height="40" viewBox="0 0 100 60"><path d="M6 42 C18 8 30 10 38 26 C56 52 78 54 94 55" fill="none" stroke="#A9A290" stroke-width="2.2" stroke-linecap="round"/><circle cx="26" cy="14" r="4.5" fill="none" stroke="#A9A290" stroke-width="2"/></svg>',
    bioage: '<svg width="46" height="46" viewBox="0 0 32 32"><circle cx="16" cy="16" r="13" fill="none" stroke="#A9A290" stroke-width="1.8"/><path d="M16 9 v7 l5 3" fill="none" stroke="#A9A290" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    omega3: '<svg width="60" height="38" viewBox="0 0 60 36"><path d="M6 18 C16 6 30 4 42 12 L54 4 L50 18 L54 32 L42 24 C30 32 16 30 6 18z" fill="none" stroke="#A9A290" stroke-width="1.8" stroke-linejoin="round"/><circle cx="16" cy="16" r="1.6" fill="#A9A290"/></svg>',
    female: '<svg width="44" height="48" viewBox="0 0 32 36"><circle cx="16" cy="10" r="4" fill="none" stroke="#A9A290" stroke-width="1.8"/><circle cx="9" cy="17" r="4" fill="none" stroke="#A9A290" stroke-width="1.8"/><circle cx="23" cy="17" r="4" fill="none" stroke="#A9A290" stroke-width="1.8"/><circle cx="16" cy="24" r="4" fill="none" stroke="#A9A290" stroke-width="1.8"/><path d="M16 28 v6" stroke="#A9A290" stroke-width="1.8" stroke-linecap="round"/></svg>',
    cac: '<svg width="46" height="42" viewBox="0 0 32 30"><path d="M16 27 C8 21 2 15.5 2 9.5 A6.8 6.8 0 0 1 16 7 A6.8 6.8 0 0 1 30 9.5 C30 15.5 24 21 16 27z" fill="none" stroke="#A9A290" stroke-width="1.8" stroke-linejoin="round"/><path d="M7 14 h5 l2 -4 3 7 2 -3 h6" fill="none" stroke="#A9A290" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    vo2max: '<svg width="48" height="44" viewBox="0 0 34 30"><path d="M4 24 A13 13 0 0 1 30 24" fill="none" stroke="#A9A290" stroke-width="1.8" stroke-linecap="round"/><path d="M17 24 L23.5 14.5" stroke="#A9A290" stroke-width="1.8" stroke-linecap="round"/><circle cx="17" cy="24" r="2.2" fill="none" stroke="#A9A290" stroke-width="1.6"/></svg>',
    quiz: '<svg width="42" height="48" viewBox="0 0 28 34"><rect x="3" y="3" width="22" height="28" rx="4" fill="none" stroke="#A9A290" stroke-width="1.8"/><path d="M8 11 l2 2 4 -4 M15 12 h6 M8 20 l2 2 4 -4 M15 21 h6" fill="none" stroke="#A9A290" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ===================== lens registry (bento order) ===================== */
  /* v5: prices mirror the diagnostics selling page (source of truth for AED). */
  var LENSES = [
    { key: "blood",    name: "Blood Panel",      addSub: "53 markers, physician reviewed", hook: "The widest single look at what's going on inside you.", price: "AED 699" },
    { key: "dexa",     name: "DEXA Scan",        addSub: "body + bone",                    hook: "Muscle, fat and bone, region by region.",             price: "AED 549" },
    { key: "gut",      name: "Gut Microbiome",   addSub: "at-home kit",                    hook: "Your inner ecosystem, mapped and fed.",               price: "AED 999" },
    { key: "dna",      name: "DNA Insights",     addSub: "once, for life",                 hook: "The owner's manual you were born with.",              price: "AED 899" },
    { key: "cortisol", name: "Cortisol Rhythm",  addSub: "stress + recovery",              hook: "Your stress hormone, across one day.",                price: "AED 449" },
    { key: "bioage",   name: "Biological Age",   addSub: "epigenetic clock",               hook: "How fast your body is actually aging.",               price: "AED 1,299" },
    { key: "omega3",   name: "Omega-3 Index",    addSub: "finger-prick card",              hook: "The fat balance your heart runs on.",                 price: "AED 349" },
    { key: "female",   name: "Female Panel",     addSub: "hormone deep dive",              hook: "Cycle, thyroid and fertility hormones in one draw.",  price: "AED 899" },
    { key: "cac",      name: "Heart Calcium",    addSub: "CT scan score",                  hook: "The most direct look at arterial plaque.",            price: "AED 849" },
    { key: "vo2max",   name: "VO2max",           addSub: "cardio fitness",                 hook: "Your cardio fitness, measured under load.", price: "AED 999" },
    { key: "quiz",     name: "Wellness Profile", addSub: "5-minute quiz",                  hook: "What matters to you, so the plan fits.",         price: "Free" }
  ];

  /* ===================== v7: who each test is for =====================
     ONE copy, two surfaces. The purchase page carries these lines as block
     settings (who_label, who1, who2, who3, who_not) in
     sections/hewyn-diagnostics-select.liquid and in
     templates/page.diagnostics-preview.json, and they derive from
     docs/superpowers/specs/2026-09-10-onboarding-recommendation-logic.md.
     The table below is the same words, byte for byte, so a visitor who reads
     "who is this for" on the zero-state card and then opens the purchase page
     is never told two different things.
     tests/hewyn-dashboard-tour.suite.js parses the purchase page's own presets
     and fails the moment one character drifts. Edit there first, then here, and
     run the suite. Keys are dashboard lens keys; the purchase page's block ids
     differ for two of them (female, cac) and the test matches on the title. */
  var WHO = {
    blood: {
      label: "Good fit if",
      lines: [
        "Almost everyone, as a first test",
        "If you're tired, foggy, or have never had a full panel",
        "If diabetes or thyroid trouble runs in your family"
      ],
      not: ""
    },
    dexa: {
      label: "Good fit if",
      lines: [
        "If weight or body composition is what you want to move",
        "If you train and want to know what's muscle and what isn't",
        "Women over 45, and anyone with osteoporosis in the family"
      ],
      not: "Not during pregnancy. The scan uses a small dose of radiation."
    },
    gut: {
      label: "Good fit if",
      lines: [
        "If bloating or digestive discomfort is part of most days",
        "If digestion is the thing you'd fix first",
        "If your gut symptoms seem to track your stress"
      ],
      not: "Not the place to start if your digestion already feels fine."
    },
    dna: {
      label: "Good fit if",
      lines: [
        "Once in a lifetime, so there's no rush and no repeat",
        "If you want your other results read against your own biology",
        "Best added after a blood panel, not before one"
      ],
      not: "Not for you if you've already had your DNA read."
    },
    cortisol: {
      label: "Good fit if",
      lines: [
        "If you're tired but wired at night",
        "If you wake around 3am, or wake up unrefreshed",
        "If you work shifts, or your stress never quite switches off"
      ],
      not: ""
    },
    bioage: {
      label: "Good fit if",
      lines: [
        "If longevity is the goal and your basics are already measured",
        "Most informative from 45 onwards"
      ],
      not: "Not a first test. It sums up systems you're better off measuring directly first."
    },
    omega3: {
      label: "Good fit if",
      lines: [
        "If you already take fish oil and want to know it's working",
        "If heart health is what you're watching",
        "If your diet is low in oily fish"
      ],
      not: "Best read alongside a blood panel rather than on its own."
    },
    female: {
      label: "Good fit if",
      lines: [
        "For women. It reads ovarian reserve and cycle hormones.",
        "If your cycle has changed, or perimenopause may have started",
        "If fertility is a question you'd like a number for"
      ],
      not: "Not during pregnancy or breastfeeding. The results can't be read."
    },
    cac: {
      label: "Good fit if",
      lines: [
        "Anyone over 45, and anyone with early heart disease in the family",
        "From 35 if a parent or sibling had heart disease before 60",
        "Once in about five years, not a number you track"
      ],
      not: "Not for under 35s. It carries a radiation dose and would almost certainly read zero."
    },
    vo2max: {
      label: "Good fit if",
      lines: [
        "If you train and want your engine measured, not estimated",
        "If you haven't trained in years and want an honest baseline",
        "If you're out of breath sooner than you used to be"
      ],
      not: "Not during pregnancy. It's a maximal effort test."
    }
  };

  /* v5: scene photography. The filenames live in the section's #hd-scenes JSON
     block, because only Liquid can turn one into a CDN URL. The defaults below
     are the same filenames, so this table is never empty and the renderers can
     be exercised with no document at all. */
  var SCENES = {
    hero: "hewyn-scene-sleep-1.jpg",
    blood: "hewyn-scene-device.jpg",
    dexa: "hewyn-scene-kitchen.jpg",
    gut: "hewyn-scene-gut-context.jpg",
    dna: "hewyn-scene-bottle.jpg",
    cortisol: "hewyn-scene-focus-desk.jpg",
    bioage: "hewyn-scene-sleep-face.jpg",
    omega3: "hewyn-scene-nutrition.jpg",
    female: "hewyn-scene-sleep-pillow.jpg",
    cac: "hewyn-scene-discovery.jpg",
    vo2max: "hewyn-scene-hydration.jpg",
    quiz: "hewyn-scene-ritual.jpg"
  };
  if (typeof document !== "undefined") {
    try {
      var sceneEl = document.getElementById("hd-scenes");
      if (sceneEl) {
        var sceneMap = JSON.parse(sceneEl.textContent || "{}");
        for (var sceneKey in sceneMap) {
          if (Object.prototype.hasOwnProperty.call(SCENES, sceneKey) && sceneMap[sceneKey]) {
            SCENES[sceneKey] = sceneMap[sceneKey];
          }
        }
      }
    } catch (_) {}
  }

  /* v5: dashboard lens key -> selling-page card anchor (ids differ for two lenses) */
  var TEST_ANCHOR = { female: "femhormone", cac: "heartcalc" };
  function testHref(key) {
    return "/pages/diagnostics-preview#test-" + (TEST_ANCHOR[key] || key);
  }

  /* Wave 1: one place that knows where a test's report lives. Blood keeps its own
     page, the quiz has its recommendations page, every other test uses the report
     engine. Returns null when a key has no readable report. */
  function lensReportHref(key, demo) {
    var k = String(key || "");
    if (!k) return null;
    if (k === "blood") return "/pages/my-recommendations" + (demo ? "?demo=1" : "");
    if (k === "quiz") return "/pages/quiz-recommendations";
    return "/pages/test-report?lens=" + k + (demo ? "&demo=1" : "");
  }

  /* ===================== system scores (computed in code) ===================== */
  /* blood categories -> systems; whole lenses -> systems; bioage feeds the chip, not a ring */
  var BLOOD_CAT_SYS = {
    "Cholesterol Profile": "Heart", "Inflammation": "Heart",
    "Blood Sugar": "Metabolic", "Liver": "Metabolic", "Kidney": "Metabolic",
    "Hormones": "Hormones", "Thyroid": "Hormones",
    "Vitamins & Minerals": "Nutrients", "Iron": "Nutrients", "Blood Count": "Nutrients"
  };
  var LENS_SYS = { omega3: "Heart", cac: "Heart", vo2max: "Heart", dexa: "Body", gut: "Gut", cortisol: "Hormones", female: "Hormones" };
  var SYS_ORDER = ["Heart", "Metabolic", "Hormones", "Nutrients", "Body", "Gut"];

  /* Wave 1 vocabulary standard: a self-ordering ladder. Optimal > Strong > Fair > Pay attention.
     The old ladder placed "In range" above "Good", which a customer cannot order. */
  function scoreLabel(score) {
    if (score >= 92) return "Optimal";
    if (score >= 80) return "Strong";
    if (score >= 65) return "Fair";
    return "Pay attention";
  }

  /* Wave 1: customer-facing display name for a lens key. Machine keys (CAC, OMEGA3,
     BIOAGE) must never reach the page. Falls back to the key only if the registry misses. */
  function lensName(key) {
    var k = String(key || "");
    for (var i = 0; i < LENSES.length; i++) if (LENSES[i].key === k) return LENSES[i].name;
    return k;
  }

  /* ===================== marker aliases (ONE table, matched through everywhere) ===================== */
  /* TWIN FILE: /Users/cemrework/projects/hewyn-agent-assist/src/lib/wellness/system-scores.ts
     The block between the two MARKER-ALIAS-TABLE sentinels below is kept BYTE IDENTICAL
     with the same block in that file. tests/hewyn-marker-aliases.suite.js recomputes the
     checksum on the sentinel line and compares the twin, and fails the moment they drift. */
  /* >>> MARKER-ALIAS-TABLE v1 sha256:4099a958a85027db70193660ab674f9f43ca2a9ff2305712f8db404cf8d9f0a1 >>> */
  /* Every analyte this codebase matches by NAME, with the real-world name variants labs
     actually print for it. Match through this table, never against an ad hoc regex, so
     "hs-CRP", "hsCRP", "CRP (high sensitivity)", "C-Reactive Protein" and
     "C-Reactive Protein (hs)" all resolve to the one analyte "crp".
     ORDER MATTERS: the first entry whose pattern matches wins, so the specific names sit
     above the generic ones (calciumScore above calcium, a1c above hemoglobin, the lipid
     ratios above ldl and hdl, nonHdl above hdl).
     This block is DATA ONLY and is kept byte identical in both repos; the twin file is
     named on the sentinel line above, and a checksum test in each repo fails on drift. */
  var MARKER_ALIASES = [
    ["il6", /\bil[-\s]?6\b|interleukin[-\s]?6/i],
    ["crp", /c[-\s]?reactive|\b(?:hs|us)[-\s]?crp\b|\bhscrp\b|\bcrp\b/i],
    ["homocysteine", /homocystein/i],
    ["esr", /\besr\b|sed(?:imentation)? rate/i],
    ["cholHdlRatio", /cholesterol\s*[\/:]\s*hdl/i],
    ["ldlHdlRatio", /ldl\s*[\/:]\s*hdl/i],
    ["tgHdlRatio", /triglycerides?\s*[\/:]\s*hdl/i],
    ["apob", /\bapo[-\s]?b\b|apolipoprotein[-\s]?b/i],
    ["lpa", /\blp\s?-?\(a\)|lipoprotein\s?\(a\)|\blp[-\s]?a\b/i],
    ["nonHdl", /non[-\s]?hdl/i],
    ["ldl", /\bldl\b|low[-\s]?density lipoprotein/i],
    ["hdl", /\bhdl\b|high[-\s]?density lipoprotein/i],
    ["vldl", /\bvldl\b/i],
    ["cholesterol", /cholesterol/i],
    ["triglycerides", /triglycer/i],
    ["omega3Index", /omega[-\s]?3|\bepa\b|\bdha\b/i],
    ["a1c", /\ba1c\b|\bh(?:b|gb|ba)?a1c\b|glyc(?:at|osylat)ed\s+h(?:a)?emoglobin|h(?:a)?emoglobin\s+a1c/i],
    ["glucose", /glucose/i],
    ["insulin", /insulin/i],
    ["homaIr", /\bhoma\b|homa[-\s]?ir/i],
    ["uricAcid", /uric acid|\burate\b/i],
    ["alt", /\balt\b|\bsgpt\b|alanine (?:amino)?transferase/i],
    ["ast", /\bast\b|\bsgot\b|aspartate (?:amino)?transferase/i],
    ["ggt", /\bggt\b|gamma[-\s]?gt\b|gamma[-\s]?glutamyl/i],
    ["alp", /\balp\b|alkaline phosphatase/i],
    ["bilirubin", /bilirubin/i],
    ["agRatio", /\ba\s*\/\s*g ratio\b|albumin\s*\/\s*globulin/i],
    ["albumin", /albumin/i],
    ["globulin", /globulin/i],
    ["totalProtein", /total protein|protein[-,\s]+total/i],
    ["bun", /\bbun\b|blood urea nitrogen/i],
    ["urea", /\burea\b/i],
    ["creatineKinase", /creatine\s?(?:phospho)?kinase|\bcpk\b|\bck\b/i],
    ["creatinine", /creatinine/i],
    ["egfr", /\begfr\b|\bgfr\b/i],
    ["testosterone", /testosterone/i],
    ["freeAndrogenIndex", /free androgen index|\bfai\b/i],
    ["shbg", /\bshbg\b|sex hormone[-\s]?binding/i],
    ["dhea", /\bdhea(?:[-\s]?s)?\b|dehydroepiandrosterone/i],
    ["estradiol", /estradiol|\be2\b/i],
    ["progesterone", /progesterone/i],
    ["prolactin", /prolactin/i],
    ["lh", /\blh\b|luteini[sz]ing hormone/i],
    ["fsh", /\bfsh\b|follicle[-\s]?stimulating/i],
    ["amh", /\bamh\b|anti[-\s]?m(?:u|ue|ü)llerian/i],
    ["cortisol", /cortisol/i],
    ["tsh", /\btsh\b|thyroid[-\s]?stimulating/i],
    ["ft3", /\bf?t3\b|free t3|triiodothyronine/i],
    ["ft4", /\bf?t4\b|free t4|thyroxine/i],
    ["thyroidOther", /thyro/i],
    ["vitaminD", /vitamin\s?d\b|25[-\s]?(?:oh|hydroxy)|calcidiol|cholecalciferol/i],
    ["vitaminB12", /vitamin\s?b\s?-?12\b|\bb\s?-?12\b|cobalamin/i],
    ["folate", /folate|folic acid/i],
    ["ferritin", /ferritin/i],
    ["tibc", /\btibc\b|total iron[-\s]?binding/i],
    ["uibc", /\buibc\b|unsaturated iron[-\s]?binding/i],
    ["transferrin", /transferrin/i],
    ["iron", /\biron\b|iron[-\s]?serum/i],
    ["magnesium", /magnesium|\bmg\b/i],
    ["zinc", /\bzinc\b|\bzn\b/i],
    ["copper", /\bcopper\b|\bcu\b/i],
    ["selenium", /selenium/i],
    ["calciumScore", /calcium score|coronary (?:artery )?calcium|\bcac\b|agatston/i],
    ["calcium", /\bcalcium\b/i],
    ["sodium", /\bsodium\b|\bna\+?\b/i],
    ["potassium", /\bpotassium\b/i],
    ["wbc", /\bwbc\b|white (?:blood )?cell|leu[ck]ocyte/i],
    ["rbc", /\brbc\b|red (?:blood )?cell|erythrocyte/i],
    ["hematocrit", /h(?:a)?ematocrit|\bhct\b/i],
    ["hemoglobin", /h(?:a)?emoglobin|\bhgb\b/i],
    ["mcv", /\bmcv\b/i],
    ["mchc", /\bmchc\b/i],
    ["mch", /\bmch\b/i],
    ["rdw", /\brdw\b/i],
    ["platelets", /platelet|\bplt\b/i],
    ["neutrophils", /neutrophil/i],
    ["lymphocytes", /lymphocyte/i],
    ["monocytes", /monocyte/i],
    ["eosinophils", /eosinophil/i],
    ["basophils", /basophil/i],
    ["vo2max", /\bvo2\s?-?max\b|\bvo2\b/i],
    ["bodyFat", /body\s?_?fat|fat\s?_?(?:pct|percent|mass)|visceral|\bvat\b|android|gynoid|trunk\s?_?fat/i],
    ["leanMass", /lean|muscle mass|fat[-\s]?free mass|appendicular|\balmi\b|\bsmi\b|\bsmm\b/i],
    ["bone", /\bbone\b|\bbmd\b|[zt]\s?-?\s?score/i],
    ["gut", /\bgut\b|microbio|diversity|shannon/i],
    ["sleep", /\bsleep\b/i],
    ["recovery", /\brecovery\b|\bhrv\b/i]
  ];

  /* Named sets of analytes. Every by-name matcher in this file is written as one of these
     group keys or as an analyte key, never as a fresh regex. */
  var MARKER_GROUPS = {
    lipids: ["cholHdlRatio", "ldlHdlRatio", "tgHdlRatio", "apob", "lpa", "nonHdl", "ldl", "hdl", "vldl", "cholesterol", "triglycerides"],
    inflammation: ["il6", "crp", "homocysteine", "esr"],
    glycemia: ["a1c", "glucose", "insulin", "homaIr"],
    liver: ["alt", "ast", "ggt", "alp", "bilirubin", "agRatio", "albumin", "globulin", "totalProtein"],
    kidney: ["bun", "urea", "creatinine", "egfr", "uricAcid"],
    hormones: ["testosterone", "freeAndrogenIndex", "shbg", "dhea", "estradiol", "progesterone", "prolactin", "lh", "fsh", "amh", "cortisol"],
    thyroid: ["tsh", "ft3", "ft4", "thyroidOther"],
    vitaminsMinerals: ["vitaminD", "vitaminB12", "folate", "magnesium", "zinc", "copper", "selenium", "calcium", "sodium", "potassium"],
    ironPanel: ["ferritin", "tibc", "uibc", "transferrin", "iron"],
    bloodCount: ["wbc", "rbc", "hematocrit", "hemoglobin", "mcv", "mchc", "mch", "rdw", "platelets", "neutrophils", "lymphocytes", "monocytes", "eosinophils", "basophils"],
    recoveryBlood: ["testosterone", "cortisol", "crp", "creatineKinase", "magnesium", "ferritin"],
    bodyComposition: ["bodyFat", "leanMass", "bone"]
  };
  /* <<< MARKER-ALIAS-TABLE v1 <<< */

  /* Canonical analyte key for a lab marker name, or null when nothing in the table fits. */
  function analyteOf(name) {
    var n = String(name == null ? "" : name);
    if (!n) return null;
    for (var i = 0; i < MARKER_ALIASES.length; i++) {
      if (MARKER_ALIASES[i][1].test(n)) return MARKER_ALIASES[i][0];
    }
    return null;
  }
  /* Expand a list of analyte keys and/or group keys into a flat set of analyte keys. */
  function analyteSet(keys) {
    var out = {}, list = isArr(keys) ? keys : [keys];
    for (var i = 0; i < list.length; i++) {
      var k = list[i];
      var g = MARKER_GROUPS[k];
      if (g) { for (var j = 0; j < g.length; j++) out[g[j]] = 1; }
      else out[k] = 1;
    }
    return out;
  }
  /* True when a marker NAME resolves to any analyte in the given keys/groups. */
  function markerIs(name, keys) {
    var a = analyteOf(name);
    return !!a && !!analyteSet(keys)[a];
  }

  /* Fallback blood category from the marker name, for findings that arrive without one.
     Mirrors categoryOf() in the twin file so the storefront and the review tool agree. */
  var CAT_GROUPS = [
    ["lipids", "Cholesterol Profile"],
    ["inflammation", "Inflammation"],
    ["glycemia", "Blood Sugar"],
    ["liver", "Liver"],
    ["kidney", "Kidney"],
    ["hormones", "Hormones"],
    ["thyroid", "Thyroid"],
    ["vitaminsMinerals", "Vitamins & Minerals"],
    ["ironPanel", "Iron"],
    ["bloodCount", "Blood Count"]
  ];
  function categoryOf(marker, given) {
    if (given && BLOOD_CAT_SYS[given]) return given;
    for (var i = 0; i < CAT_GROUPS.length; i++) {
      if (markerIs(marker, CAT_GROUPS[i][0])) return CAT_GROUPS[i][1];
    }
    return given || "Other";
  }

  /* Pure: derive system rings from raw lens data. Used when no ai_insights exist. */
  function computeRings(data) {
    data = data || {};
    var acc = {}; /* system -> {inRange, attention, lenses:{}} */
    function bump(sys, ok, at, lens) {
      if (!acc[sys]) acc[sys] = { inRange: 0, attention: 0, lenses: {} };
      acc[sys].inRange += ok; acc[sys].attention += at;
      if (lens) acc[sys].lenses[lens] = 1;
    }
    var blood = data.blood;
    if (blood && typeof blood === "object" && !isProcessing(blood) && isArr(blood.findings)) {
      blood.findings.forEach(function (f) {
        var sys = BLOOD_CAT_SYS[categoryOf((f && (f.marker || f.name)) || "", f && f.category)] || null;
        if (!sys) return;
        var st = statusOf(f && f.flag);
        bump(sys, st === "ok" ? 1 : 0, st === "ok" ? 0 : 1, "blood");
      });
    }
    Object.keys(LENS_SYS).forEach(function (k) {
      var d = data[k];
      if (!d || typeof d !== "object" || isProcessing(d)) return;
      var c = lensCounts(k, d);
      if (c) bump(LENS_SYS[k], c.inRange, c.attention, k);
    });
    var rings = [];
    SYS_ORDER.forEach(function (sys) {
      var a = acc[sys];
      if (!a) return;
      var total = a.inRange + a.attention;
      if (!total) return;
      var score = Math.round(100 * a.inRange / total);
      rings.push({ system: sys, score: score, label: scoreLabel(score), trend: null, drivers: null, lenses: Object.keys(a.lenses) });
    });
    return rings.slice(0, 6);
  }

  /* ===================== Recovery ring (deterministic, mirrors backend) ===================== */
  /* Contributors: every cortisol-lens marker; blood markers matching the substring list;
     one sleep pseudo-marker from intake (>= 6 hrs ok, under 6 warn). Renders only when
     at least two contributors exist. Score = round(100 * in-range / total). */
  /* Blood markers that feed Recovery in addition to their category system; the overlap is
     intended (CRP feeds both Heart and Recovery). Resolved through the alias table, so
     "hs-CRP", "hsCRP", "CRP (high sensitivity)" and "C-Reactive Protein" all count. */
  function isRecoveryBloodMarker(name) { return markerIs(name, "recoveryBlood"); }
  function sleepHoursOf(intake) {
    if (!intake || typeof intake !== "object") return null;
    var keys = ["sleepHours", "sleep_hours", "avgSleep", "averageSleep", "sleep"];
    for (var i = 0; i < keys.length; i++) {
      if (intake[keys[i]] == null) continue;
      var m = String(intake[keys[i]]).match(/(\d+(?:\.\d+)?)/);
      if (m) return parseFloat(m[1]);
    }
    return null;
  }
  function computeRecoveryRing(data) {
    data = data || {};
    var ok = 0, total = 0, drivers = [], lenses = {};
    function add(st, lens, name, val) {
      total++;
      lenses[lens] = 1;
      if (st === "ok") { ok++; return; }
      if (name) drivers.push((name + " " + (val == null ? "" : String(val))).replace(/\s+$/, ""));
    }
    /* 1) all markers of the cortisol lens */
    var cort = data.cortisol;
    if (cort && typeof cort === "object" && !isProcessing(cort)) {
      var cf = isArr(cort.findings) ? cort.findings : (isArr(cort.markers) ? cort.markers : null);
      if (cf && cf.length) {
        cf.forEach(function (f) {
          if (!f) return;
          add(statusOf(f.flag), "cortisol", f.marker || f.name || "Cortisol", f.value);
        });
      } else {
        var cc = lensCounts("cortisol", cort);
        if (cc) {
          for (var i = 0; i < cc.inRange; i++) add("ok", "cortisol");
          for (var j = 0; j < cc.attention; j++) add("warn", "cortisol", "Cortisol rhythm", cort.car);
        }
      }
    }
    /* 2) blood markers on the recovery list */
    var blood = data.blood;
    if (blood && typeof blood === "object" && !isProcessing(blood) && isArr(blood.findings)) {
      blood.findings.forEach(function (f) {
        var name = (f && (f.marker || f.name)) || "";
        if (!isRecoveryBloodMarker(name)) return;
        add(statusOf(f.flag), "blood", name, f.value);
      });
    }
    /* 3) intake sleep pseudo-marker */
    var hrs = sleepHoursOf(data.quizIntake);
    if (hrs != null) {
      if (hrs < 6) add("warn", "quiz", "Sleep under 6 hrs");
      else add("ok", "quiz", "Sleep 7+ hrs");
    }
    if (total < 2) return null;
    var score = Math.round(100 * ok / total);
    return {
      system: "Recovery", score: score, label: scoreLabel(score), trend: null,
      drivers: drivers.length ? drivers.slice(0, 3) : null, lenses: Object.keys(lenses)
    };
  }

  /* ===================== v3: marker index (every known marker across lenses) ===================== */
  /* Entry: { name, value, unit, range, status ("ok"|"warn"), systems [..], lens }.
     Feeds ring drill-down contributor bars, impact derivation, insight chips and
     the plan projection. "warn" covers every non-ok status (calm zones, no red). */
  function markerIndex(data) {
    data = data || {};
    var out = [];
    function push(name, value, unit, range, ok, systems, lens) {
      out.push({ name: name, value: value, unit: unit || "", range: range || "", status: ok ? "ok" : "warn", systems: systems, lens: lens });
    }
    var blood = data.blood;
    if (blood && typeof blood === "object" && !isProcessing(blood) && isArr(blood.findings)) {
      blood.findings.forEach(function (f) {
        if (!f || !(f.marker || f.name)) return;
        var name = f.marker || f.name;
        var sys = [];
        var mapped = BLOOD_CAT_SYS[categoryOf(name, f.category)];
        if (mapped) sys.push(mapped);
        if (isRecoveryBloodMarker(name) && sys.indexOf("Recovery") < 0) sys.push("Recovery");
        push(name, f.value, f.unit, f.range, statusOf(f.flag) === "ok", sys, "blood");
      });
    }
    var cort = data.cortisol;
    if (cort && typeof cort === "object" && !isProcessing(cort)) {
      var cf = isArr(cort.findings) ? cort.findings : (isArr(cort.markers) ? cort.markers : []);
      cf.forEach(function (f) {
        if (!f) return;
        push(f.marker || f.name || "Cortisol", f.value, f.unit, f.range, statusOf(f.flag) === "ok", ["Hormones", "Recovery"], "cortisol");
      });
    }
    var om = data.omega3;
    if (om && typeof om === "object" && !isProcessing(om) && om.index != null) {
      push("Omega-3 Index", om.index, "%", "8-12", om.index >= 8, ["Heart"], "omega3");
    }
    var vo = data.vo2max;
    if (vo && typeof vo === "object" && !isProcessing(vo) && vo.vo2max != null) {
      push("VO2max", vo.vo2max, "ml/kg/min", ">43", true, ["Heart"], "vo2max");
    }
    var cac = data.cac;
    if (cac && typeof cac === "object" && !isProcessing(cac) && cac.score != null) {
      push("Calcium score", cac.score, "", "0", cac.score < 100, ["Heart"], "cac");
    }
    var dx = data.dexa;
    if (dx && typeof dx === "object" && !isProcessing(dx)) {
      if (dx.bodyFat != null) push("Body fat", dx.bodyFat, "%", "14-20", true, ["Body"], "dexa");
      if (dx.leanMass != null) push("Lean mass", dx.leanMass, "", "", true, ["Body"], "dexa");
      if (dx.boneZ != null) push("Bone Z-score", dx.boneZ, "", "> -1", dx.boneZ > -1, ["Body"], "dexa");
    }
    var gut = data.gut;
    if (gut && typeof gut === "object" && !isProcessing(gut) && gut.score != null) {
      /* one scale only: the gut score is 0-100, exactly as the gut report hero renders it.
         It used to be pushed as diversity on a 0-10 scale, which put two numbers for the
         same test one tap apart. */
      push("Gut score", gut.score, "/100", "65 or above", gut.score >= 65, ["Gut"], "gut");
    }
    var hrs = sleepHoursOf(data.quizIntake);
    if (hrs != null) push("Sleep", hrs, "hrs", "7-9", hrs >= 6, ["Recovery"], "quiz");
    return out;
  }

  /* ===================== markers behind the headline =====================
     The hero headline would rather say "your vitamin D is low" than "Nutrients
     needs attention", so it needs the out-of-range markers for one system and,
     when every one of them agrees, which way they miss.
     markerDir reads the marker's own printed range, so it can only ever say
     "low" or "high" when the range is a plain low-to-high pair and the value is
     a number. Anything else returns null and the wording stays neutral. */
  function markerDir(m) {
    if (!m || m.value == null) return null;
    var v = parseFloat(String(m.value));
    if (isNaN(v)) return null;
    var r = String(m.range || "").replace(/\s/g, "");
    var pair = r.match(/^(-?\d+(?:\.\d+)?)(?:-|to)(-?\d+(?:\.\d+)?)$/);
    if (pair) {
      var lo = parseFloat(pair[1]), hi = parseFloat(pair[2]);
      if (v < lo) return "low";
      if (v > hi) return "high";
      return null;
    }
    var gt = r.match(/^>=?(-?\d+(?:\.\d+)?)$/);
    if (gt) return v < parseFloat(gt[1]) ? "low" : null;
    var lt = r.match(/^<=?(-?\d+(?:\.\d+)?)$/);
    if (lt) return v > parseFloat(lt[1]) ? "high" : null;
    return null;
  }
  /* "Vitamin D" reads wrong mid-sentence, "HbA1c" and "LDL" read wrong lowered.
     Only drop the case when the name is a plain capitalized word. */
  function markerInline(name) {
    var s = String(name || "");
    return /^[A-Z][a-z]/.test(s) ? s.charAt(0).toLowerCase() + s.slice(1) : s;
  }
  function focusMarkers(system, index) {
    var out = { names: [], dir: null };
    if (!isArr(index)) return out;
    var hits = index.filter(function (m) {
      return m && m.status === "warn" && isArr(m.systems) && m.systems.indexOf(system) > -1;
    });
    if (!hits.length) return out;
    out.names = hits.map(function (m) { return markerInline(m.name); });
    /* nobody says "vitamin D and vitamin B12" out loud */
    if (out.names.length === 2) {
      var a = out.names[0].split(" "), b = out.names[1].split(" ");
      if (a.length > 1 && b.length > 1 && a[0].toLowerCase() === b[0].toLowerCase()) {
        out.names[1] = b.slice(1).join(" ");
      }
    }
    var dirs = hits.map(markerDir);
    if (dirs.length && dirs[0] && dirs.every(function (d) { return d === dirs[0]; })) out.dir = dirs[0];
    return out;
  }

  /* ci match: index entry whose name contains the query or vice versa */
  function findMarker(name, index) {
    var q = String(name || "").toLowerCase();
    if (!q) return null;
    for (var i = 0; i < index.length; i++) {
      var n = index[i].name.toLowerCase();
      if (n === q) return index[i];
    }
    /* pass 2: the two names are different registers for the same analyte, e.g. an AI
       written "hs-CRP" against an index entry named "C-Reactive Protein". This runs BEFORE
       the loose substring pass, which would otherwise resolve "Hemoglobin A1c" to the
       "Hemoglobin" row because one name contains the other. */
    var a = analyteOf(name);
    if (a) {
      for (var k = 0; k < index.length; k++) if (analyteOf(index[k].name) === a) return index[k];
    }
    /* pass 3: loose containment, for names the alias table does not know */
    for (var j = 0; j < index.length; j++) {
      var m = index[j].name.toLowerCase();
      if (m.indexOf(q) > -1 || q.indexOf(m) > -1) return index[j];
    }
    return null;
  }

  /* Analyte/group keys -> systems, for a marker name that is not in the index. Written in
     alias keys so a name variant can never slip past it the way "Hemoglobin A1c" used to
     slip past /hba1c/ and "Apolipoprotein B" past /apob/. */
  var MARKER_SYS_FALLBACK = [
    [["lipids", "inflammation", "omega3Index", "calciumScore", "vo2max"], ["Heart"]],
    [["hormones", "thyroid"], ["Hormones"]],
    [["vitaminsMinerals", "ironPanel"], ["Nutrients"]],
    [["glycemia"], ["Metabolic"]],
    [["bodyComposition"], ["Body"]],
    [["sleep", "recovery"], ["Recovery"]],
    [["gut"], ["Gut"]]
  ];
  function systemsOfMarker(name, index) {
    var hit = findMarker(name, index || []);
    if (hit && hit.systems && hit.systems.length) return hit.systems;
    for (var i = 0; i < MARKER_SYS_FALLBACK.length; i++) {
      if (markerIs(name, MARKER_SYS_FALLBACK[i][0])) return MARKER_SYS_FALLBACK[i][1];
    }
    return [];
  }

  /* ===================== v3: ring drill-down contributors ===================== */
  /* Fill position of a value inside its printed range, 0..1, for the bar. */
  function barPos(value, range) {
    var v = parseFloat(String(value == null ? "" : value).replace(/[^0-9.\-]/g, ""));
    if (isNaN(v)) return 0.5;
    var r = String(range || "");
    var m = r.match(/(-?\d+(?:\.\d+)?)\s*-\s*(-?\d+(?:\.\d+)?)/);
    if (m) {
      var a = parseFloat(m[1]), b = parseFloat(m[2]);
      if (b > a) return Math.max(0.04, Math.min(1, (v - a) / (b - a)));
    }
    m = r.match(/^[<>=\s]*(-?\d+(?:\.\d+)?)/);
    if (m) {
      var lim = parseFloat(m[1]);
      if (lim !== 0) return Math.max(0.04, Math.min(1, v / (lim * 1.4)));
    }
    return 0.5;
  }
  /* Every marker feeding a system, out-of-range first. Works for AI-scored and
     computed rings alike because it reads raw lens data, not ai.drivers. */
  function ringContributors(ring, index) {
    var rows = (index || []).filter(function (m) {
      return m.systems && m.systems.indexOf(ring.system) > -1;
    });
    rows.sort(function (a, b) {
      if (a.status !== b.status) return a.status === "warn" ? -1 : 1;
      return 0;
    });
    return rows;
  }
  var SYSTEM_EXPLAIN = {
    Heart: "Your heart and your blood vessels. The fats that build plaque, the inflammation behind it, and the fitness that holds it off.",
    Metabolic: "How your body handles fuel. Blood sugar control, plus the liver and kidney chemistry behind it.",
    Hormones: "Your thyroid, your sex hormones and your stress hormone rhythm. The messages everything else runs on.",
    Nutrients: "The vitamins and minerals your energy, mood and recovery are built from.",
    Body: "What you're made of. Muscle, where the fat sits, and how strong your bones are, all from your DEXA.",
    Gut: "The bugs that do your digesting, and how varied and balanced they are.",
    Recovery: "How well you bounce back. Your cortisol rhythm, the blood markers that show strain, and your sleep."
  };

  /* ===================== v3: impact + care actions ===================== */
  /* Impact chip: explicit action.impact wins; otherwise an action targeting at
     least one currently out-of-range marker is High, everything else Medium. */
  function impactOf(action, index) {
    var given = String((action && action.impact) || "").toLowerCase();
    if (given === "high" || given === "medium" || given === "low") return given;
    var list = (action && action.improves) || [];
    for (var i = 0; i < list.length; i++) {
      var hit = findMarker(list[i] && list[i].marker, index || []);
      if (hit && hit.status === "warn") return "high";
    }
    return "medium";
  }
  /* Care Actions: clinical follow-ups derived from data (retest cadences per
     lens + physician review for any pay-attention system). Max 4 rows. */
  function buildCareActions(data, rings) {
    data = data || {};
    var acts = [];
    var blood = data.blood;
    if (blood && typeof blood === "object" && !isProcessing(blood)) {
      var pub = lensDate("blood", blood);
      var weeks = parseFloat(blood.retestWeeks) || 12;
      var when = pub ? new Date(pub.getTime() + weeks * 7 * 86400000) : null;
      acts.push({ id: "care-blood", title: "Book your blood retest", frequency: "every " + weeks + " wks", source: "physician", care: true,
        why: "You only get a trend line if you retest." + (when ? " Yours opens ~" + fmtD(when) + "." : ""), improves: [] });
    }
    var om = data.omega3;
    if (om && typeof om === "object" && !isProcessing(om) && om.index != null && om.index < 8) {
      acts.push({ id: "care-omega3", title: "Omega-3 recheck after 120 days", frequency: "120 days", source: "physician", care: true,
        why: "Your red blood cells turn over in about four months, so a retest sooner than that can't show the change.", improves: [] });
    }
    var cort = data.cortisol;
    if (cort && typeof cort === "object" && !isProcessing(cort)) {
      var cc = lensCounts("cortisol", cort);
      if (cc && cc.attention > 0) {
        acts.push({ id: "care-cortisol", title: "Repeat cortisol rhythm in 8-12 weeks", frequency: "8-12 wks", source: "physician", care: true,
          why: "Long enough for the wind-down changes to show up in the curve.", improves: [] });
      }
    }
    var attn = (rings || []).filter(function (r) { return r && r.label === "Pay attention"; });
    if (attn.length) {
      acts.push({ id: "care-review", title: "Review " + attn[0].system.toLowerCase() + " results with your physician", frequency: "once", source: "physician", care: true,
        why: "A ten-minute call to check the plan still matches your " + attn[0].system.toLowerCase() + " numbers.", improves: [] });
    }
    return acts.slice(0, 4);
  }

  /* ===================== v3: plan projection (the action -> outcome bridge) ===================== */
  /* Deterministic model, documented so support can explain any number:
     - Start from each system ring's current score.
     - Every ACTIVE action (status proposed or accepted, i.e. not rejected)
       contributes credit to each system its "improves" markers belong to:
         High impact -> 6 points, Medium -> 3 points,
         reduced to 1 when none of its markers in that system are out of range
         (already-in-range work maintains more than it moves).
     - Per system, credits are sorted largest first and summed with diminishing
       returns (each subsequent action counts 60% of the previous weight:
       total = sum(credit_i * 0.6^i), rounded). This keeps every accept/reject
       consequential even on well-covered systems.
     - Total added credit per system is capped at +24 and the projected score
       is capped at 96. Systems with no credit are omitted from the bars.
     - Marker-level expected rows come from ai.futureOutlook.expected, grouped
       under the system their marker belongs to. Toggling an action off removes
       its credit, so the bars recompute live. */
  function computeOutlook(rings, routine, routineState, index, outlookData) {
    var per = {}; /* system -> [credits] */
    ((routine && routine.stacks) || []).forEach(function (st) {
      (st.actions || []).forEach(function (a) {
        if (actionStatus(a, routineState || {}) === "rejected") return;
        var imp = impactOf(a, index);
        var base = imp === "high" ? 6 : 3;
        var sysHit = {}; /* system -> hasWarnMarker */
        (a.improves || []).forEach(function (im) {
          if (!im || !im.marker) return;
          var systems = systemsOfMarker(im.marker, index);
          var hit = findMarker(im.marker, index);
          var warn = !!(hit && hit.status === "warn");
          systems.forEach(function (s) {
            if (sysHit[s] == null) sysHit[s] = warn;
            else sysHit[s] = sysHit[s] || warn;
          });
        });
        Object.keys(sysHit).forEach(function (s) {
          if (!per[s]) per[s] = [];
          per[s].push(sysHit[s] ? base : 1);
        });
      });
    });
    var expected = (outlookData && isArr(outlookData.expected)) ? outlookData.expected : [];
    var bars = [];
    (rings || []).forEach(function (r) {
      if (!r || per[r.system] == null) return;
      var credits = per[r.system].slice().sort(function (a, b) { return b - a; });
      var sum = 0;
      credits.forEach(function (c, i) { sum += c * Math.pow(0.6, i); });
      var credit = Math.min(24, Math.round(sum));
      var to = Math.min(96, r.score + credit);
      if (to <= r.score) return;
      bars.push({ system: r.system, from: r.score, to: to, marks: [] });
    });
    /* One marker, one row. A marker that feeds two systems (waking cortisol feeds
       Hormones and Recovery) used to print an identical projection row under both.
       It now lands once, under the first system it belongs to that has a bar. */
    var barBySystem = {};
    bars.forEach(function (b) { barBySystem[b.system] = b; });
    expected.forEach(function (e) {
      if (!e || !e.marker) return;
      var systems = systemsOfMarker(e.marker, index);
      var target = null;
      for (var si = 0; si < systems.length; si++) {
        if (barBySystem[systems[si]]) { target = barBySystem[systems[si]]; break; }
      }
      if (!target) return;
      var hit = findMarker(e.marker, index);
      target.marks.push({
        marker: e.marker, from: e.from, toRange: e.toRange,
        /* today's value carries the attention tone when the marker is out of
           range, so a green target never implies today is already fine. */
        warn: !!(hit && hit.status === "warn")
      });
    });
    return {
      byDate: (outlookData && outlookData.byDate) || null,
      bars: bars
    };
  }

  /* ===================== v3: insights model ===================== */
  /* Slot count scales with data: blood-only shows 3, each additional ready lens
     adds one slot, capped at 6. lensCount excludes the quiz. */
  function insightSlots(lensCount) {
    return Math.min(6, 3 + Math.max(0, (lensCount || 1) - 1));
  }
  /* Marker chips for a card: explicit c.markers wins, else scan the marker index
     for names mentioned in the card text (real-mode enrichment without AI). */
  function insightMarkers(c, index) {
    if (c && isArr(c.markers) && c.markers.length) return c.markers.slice(0, 4);
    var text = ((c && c.title) || "") + " " + ((c && c.narrative) || "");
    var low = text.toLowerCase();
    var out = [];
    (index || []).forEach(function (m) {
      if (out.length >= 4) return;
      if (m.name.length < 3) return;
      if (low.indexOf(m.name.toLowerCase()) > -1) {
        out.push({ name: m.name, value: m.value, unit: m.unit, target: m.range });
      }
    });
    return out;
  }
  function insightSystems(c, markers, index) {
    if (c && isArr(c.systems) && c.systems.length) return c.systems.slice(0, 3);
    var seen = {}, out = [];
    (markers || []).forEach(function (m) {
      systemsOfMarker(m.name, index).forEach(function (s) {
        if (!seen[s]) { seen[s] = 1; out.push(s); }
      });
    });
    return out.slice(0, 3);
  }

  /* ===================== v3: blood marker browser model ===================== */
  /* Triage buckets: every out-of-range row first, then in-range grouped into
     category accordions with counts. Works on demo findings and on the real
     wellness_plan findings (same shape: marker/value/unit/range/flag/category). */
  function bloodBrowserModel(findings) {
    var out = [], cats = {}, order = [];
    (findings || []).forEach(function (f) {
      if (!f || !(f.marker || f.name)) return;
      var row = { name: f.marker || f.name, value: f.value, unit: f.unit || "", range: f.range || "", status: statusOf(f.flag) === "ok" ? "ok" : "warn" };
      if (row.status === "warn") { out.push(row); return; }
      var cat = f.category || "Other";
      if (!cats[cat]) { cats[cat] = []; order.push(cat); }
      cats[cat].push(row);
    });
    return {
      out: out,
      cats: order.map(function (c) { return { name: c, rows: cats[c], count: cats[c].length }; }),
      total: out.length + order.reduce(function (n, c) { return n + cats[c].length; }, 0)
    };
  }

  /* ===================== routine state (localStorage hewyn_routine_v1) ===================== */
  var ROUTINE_KEY = "hewyn_routine_v1";
  function loadRoutineState(storage) {
    try {
      var raw = storage.getItem(ROUTINE_KEY);
      var obj = raw ? JSON.parse(raw) : null;
      return (obj && typeof obj === "object") ? obj : {};
    } catch (_) { return {}; }
  }
  function saveRoutineState(storage, state) {
    try { storage.setItem(ROUTINE_KEY, JSON.stringify(state || {})); return true; } catch (_) { return false; }
  }
  /* Pure: toggle semantics. Tapping the same status again returns to proposed. */
  function setActionStatus(state, actionId, status) {
    var next = {};
    Object.keys(state || {}).forEach(function (k) { next[k] = state[k]; });
    if (next[actionId] === status) delete next[actionId];
    else next[actionId] = status;
    return next;
  }
  function actionStatus(action, state) {
    var s = state && state[action.id];
    if (s === "accepted" || s === "rejected") return s;
    return action.status === "accepted" || action.status === "rejected" ? action.status : "proposed";
  }
  function stackCounts(stack, state) {
    var active = 0, total = 0;
    (stack.actions || []).forEach(function (a) {
      total++;
      if (actionStatus(a, state) !== "rejected") active++;
    });
    return { active: active, total: total };
  }
  /* Pure: dedupe improves targets across non-rejected actions. */
  function improvesList(routine, state) {
    var seen = {}, out = [];
    ((routine && routine.stacks) || []).forEach(function (st) {
      (st.actions || []).forEach(function (a) {
        if (actionStatus(a, state) === "rejected") return;
        (a.improves || []).forEach(function (im) {
          if (!im || !im.marker || seen[im.marker]) return;
          seen[im.marker] = 1;
          out.push(im);
        });
      });
    });
    return out;
  }

  /* ===================== compute model (pure, testable) ===================== */
  function compute(data, opts) {
    data = data || {};
    opts = opts || {};
    var intake = (data.quizIntake && typeof data.quizIntake === "object") ? data.quizIntake : {};
    var gender = String(intake.gender || intake.sex || "").toLowerCase();
    var showFemale = opts.demo ? false : gender.indexOf("male") !== 0 || gender.indexOf("female") === 0;
    /* gender "male" hides the female panel tile; unknown or female shows it.
       Demo persona Alex is male, so demo never shows the female panel, even as an add tile. */

    var tiles = [];
    var totals = { inRange: 0, attention: 0 };
    var readyCount = 0;
    var latest = null;
    var processing = [];

    LENSES.forEach(function (L) {
      if (L.key === "female" && !showFemale) return;

      var d = null, state = "add";
      if (L.key === "quiz") {
        var goals = isArr(data.quizGoals) ? data.quizGoals : null;
        if (goals && goals.length) { state = "ready"; d = { goals: goals, intake: intake }; }
      } else {
        d = data[L.key];
        if (isProcessing(d)) state = "processing";
        else if (d && typeof d === "object") state = "ready";
      }

      var counts = state === "ready" ? lensCounts(L.key, d) : null;
      if (counts) { totals.inRange += counts.inRange; totals.attention += counts.attention; }
      if (state === "ready") {
        readyCount++;
        var dt = lensDate(L.key, d);
        if (dt && (!latest || dt > latest)) latest = dt;
      }
      if (state === "processing") processing.push({ lens: L, data: d });

      tiles.push({ key: L.key, lens: L, state: state, data: d, counts: counts });
    });

    /* retest date from blood */
    var retest = null;
    var blood = data.blood;
    if (blood && typeof blood === "object" && !isProcessing(blood)) {
      var pub = lensDate("blood", blood);
      var weeks = parseFloat(blood.retestWeeks) || 12;
      if (pub) retest = new Date(pub.getTime() + weeks * 7 * 86400000);
    }

    /* next-up line */
    var nextUp = null;
    if (retest) nextUp = "Blood retest opens ~" + fmtD(retest) + ". Anything else you test before then makes that report sharper.";
    if (processing.length) {
      var p = processing[0];
      var eta = p.data && p.data.eta ? String(p.data.eta) : "soon";
      var line = p.lens.name + " results " + (eta === "soon" ? "arrive soon" : "~" + eta) + ".";
      nextUp = nextUp ? line + " " + nextUp : line;
    }
    if (!nextUp && readyCount > 0) nextUp = "It's coming together. Every test you add makes the next recommendation sharper.";
    if (!nextUp) nextUp = "Start with one test and this page starts filling in.";

    /* ===== AI layer ===== */
    var aiRaw = (data.ai && typeof data.ai === "object") ? data.ai : null;
    var ringsSrc = aiRaw && isArr(aiRaw.systemScores) && aiRaw.systemScores.length ? aiRaw.systemScores : null;
    var rings = ringsSrc ? ringsSrc.map(function (s) {
      return {
        system: s.system, score: s.score,
        /* Wave 1: the ladder is derived from the score, never taken from the payload.
           An upstream "Good"/"In range" label can no longer contradict the standard. */
        label: (typeof s.score === "number") ? scoreLabel(s.score) : (s.label || null),
        trend: (typeof s.trend === "number" ? s.trend : null),
        drivers: isArr(s.drivers) ? s.drivers : null,
        lenses: isArr(s.lenses) ? s.lenses : []
      };
    }).slice(0, 6) : computeRings(data);

    /* Recovery ring rides along whichever source built the row (AI or computed). */
    var hasRecovery = rings.some(function (r) { return r && r.system === "Recovery"; });
    if (!hasRecovery) {
      var recRing = computeRecoveryRing(data);
      if (recRing) rings = rings.concat([recRing]);
    }

    var totalMarks = totals.inRange + totals.attention;
    var overallScore = totalMarks ? Math.round(100 * totals.inRange / totalMarks) : null;

    var bioChips = null;
    var bio = data.bioage;
    if (bio && typeof bio === "object" && !isProcessing(bio) && bio.bioAge != null && bio.chronoAge != null) {
      var delta = Math.round((bio.chronoAge - bio.bioAge) * 10) / 10;
      bioChips = {
        bioAge: bio.bioAge,
        deltaText: delta >= 0 ? delta + " yrs under" : Math.abs(delta) + " yrs over",
        under: delta >= 0
      };
    }

    /* v3: shared marker index for drill-downs, impact, insights and projection */
    var mIndex = markerIndex(data);
    /* ready lenses excluding the quiz, for insight slot scaling */
    var lensReady = 0;
    tiles.forEach(function (t) { if (t.state === "ready" && t.key !== "quiz") lensReady++; });

    var insights = null, insightsMore = null, insightsQuiet = false;
    if (aiRaw && isArr(aiRaw.combinations) && aiRaw.combinations.length) {
      var all = aiRaw.combinations.map(function (c) {
        var mks = insightMarkers(c, mIndex);
        return {
          title: c.title, narrative: c.narrative,
          lenses: isArr(c.lenses) ? c.lenses : [],
          severity: c.severity === "attention" ? "attention" : "ok",
          markers: mks,
          systems: insightSystems(c, mks, mIndex)
        };
      });
      var slots = insightSlots(lensReady);
      insights = all.slice(0, slots);
      if (all.length > slots) insightsMore = all.slice(slots);
    } else if (readyCount > 0 && !opts.demo) {
      insightsQuiet = true;
    }

    var routine = null, plan = null;
    if (aiRaw && aiRaw.routine && isArr(aiRaw.routine.stacks) && aiRaw.routine.stacks.length) {
      var rState = opts.routineState || {};
      var stacks = aiRaw.routine.stacks.map(function (st) {
        var c = stackCounts(st, rState);
        return { id: st.id, title: st.title, tagline: st.tagline || "", actions: st.actions || [], active: c.active, total: c.total };
      });
      /* v3: derived Care Actions group (clinical follow-ups), skipped if the
         backend ever ships its own "care" stack */
      var hasCare = stacks.some(function (st) { return st.id === "care"; });
      if (!hasCare) {
        var careActs = buildCareActions(data, rings);
        if (careActs.length) {
          var careStack = { id: "care", title: "Care Actions", tagline: "Clinical follow-ups", actions: careActs };
          var cc2 = stackCounts(careStack, rState);
          careStack.active = cc2.active; careStack.total = cc2.total;
          stacks.push(careStack);
        }
      }
      routine = {
        goals: isArr(aiRaw.routine.goals) ? aiRaw.routine.goals : (isArr(data.quizGoals) ? data.quizGoals : []),
        stacks: stacks,
        improves: improvesList(aiRaw.routine, rState)
      };
      /* v3: the action -> outcome bridge (recomputes on every toggle) */
      var outlookData = aiRaw.futureOutlook || {};
      plan = computeOutlook(rings, { stacks: stacks }, rState, mIndex, {
        byDate: outlookData.byDate || (retest ? MONTHS[retest.getMonth()] : null),
        expected: isArr(outlookData.expected) ? outlookData.expected : []
      });
    }

    /* v3: data-led hero line ("2 systems need attention, Nutrients most") */
    var heroLine = null;
    if (rings && rings.length) {
      var attnRings = rings.filter(function (r) { return r.label === "Pay attention"; });
      if (attnRings.length) {
        var lowest = attnRings.reduce(function (a, b) { return b.score < a.score ? b : a; });
        heroLine = attnRings.length + " system" + (attnRings.length > 1 ? "s" : "") + " need" + (attnRings.length > 1 ? "" : "s") + " attention, " + lowest.system + " most.";
      } else {
        heroLine = "All " + rings.length + " systems in range.";
      }
    }

    /* The verdict, which is the headline of the whole page. It is computed from
       the same rings the ledger renders, so it can never disagree with the list
       under it, and it is written the way a doctor would say it out loud: the
       actual markers where we know them, the system name where we do not.
       Three parts, because the middle one is set in the status ink:
         heldText  what comes before the emphasis, spacing included
         focus     the emphasized words, a marker list or a system name
         tailText  what comes after, spacing included
       "low" and "high" are only ever claimed when the marker's own range says
       so and every named marker agrees; otherwise the wording stays neutral. */
    var verdict = null, focusRing = null;
    if (rings && rings.length) {
      var attnV = rings.filter(function (r) { return r.label === "Pay attention"; });
      var held = rings.length - attnV.length;
      /* "the rest look good" is only true when nothing else sits on the Fair
         rung, so the closing sentence has two forms and picks the honest one. */
      var restStrong = rings.every(function (r) {
        return r.label === "Pay attention" || r.score >= 80;
      });
      function restSentence() {
        if (!held) return "";
        if (restStrong) {
          return held === 1 ? " Your other system looks good."
                            : " Your other " + numWord(held) + " systems look good.";
        }
        /* something else sits on the Fair rung, so the honest closing line is the
           ladder word itself rather than a clean bill. */
        return " The rest are fair or better.";
      }
      if (attnV.length) {
        focusRing = attnV.reduce(function (a, b) { return b.score < a.score ? b : a; });
        var fm = focusMarkers(focusRing.system, mIndex);
        if (attnV.length === 2) {
          /* two is short enough to name both, and naming both is what a person
             would do instead of counting them. */
          verdict = {
            held: held,
            heldText: "",
            focus: attnV[0].system + " and " + attnV[1].system,
            tailText: " both need attention." + restSentence()
          };
        } else if (attnV.length > 2) {
          /* past two the list stops being a sentence, so the headline counts
             them and points at where to start. */
          verdict = {
            held: held,
            heldText: cap(numWord(attnV.length)) + " of your systems need attention. Start with ",
            focus: focusRing.system,
            tailText: "."
          };
        } else if (fm.names.length && fm.names.length < 3 && fm.dir) {
          verdict = {
            held: held,
            heldText: "Your ",
            focus: fm.names.join(" and "),
            tailText: (fm.names.length > 1 ? " are " : " is ") + fm.dir + "." + restSentence()
          };
        } else if (fm.names.length && fm.names.length < 3) {
          verdict = {
            held: held,
            heldText: "Your ",
            focus: fm.names.join(" and "),
            tailText: (fm.names.length > 1 ? " are " : " is ") + "outside the healthy range." + restSentence()
          };
        } else if (fm.names.length) {
          verdict = {
            held: held,
            heldText: "",
            focus: focusRing.system,
            tailText: " needs attention. " + cap(numWord(fm.names.length)) +
              " of its markers are outside the healthy range." + restSentence()
          };
        } else {
          verdict = {
            held: held,
            heldText: "",
            focus: focusRing.system,
            tailText: " needs attention." + restSentence()
          };
        }
      } else if (restStrong) {
        verdict = {
          held: held,
          heldText: held === 1 ? "Everything we can score looks good."
                               : "You're in good shape across all " + numWord(held) + " systems.",
          focus: null,
          tailText: ""
        };
      } else {
        /* nothing is flagged, but something is close enough that naming it is
           more use than a clean bill. */
        var watch = rings.reduce(function (a, b) { return b.score < a.score ? b : a; });
        verdict = {
          held: held,
          heldText: "Nothing needs attention right now. ",
          focus: watch.system,
          tailText: " is the one to keep an eye on."
        };
      }
    }

    /* next steps (3 rows max) */
    var nextSteps = null;
    if (aiRaw) {
      nextSteps = [];
      if (routine) {
        var waiting = 0;
        routine.stacks.forEach(function (st) {
          st.actions.forEach(function (a) { if (actionStatus(a, opts.routineState || {}) === "proposed") waiting++; });
        });
        nextSteps.push({ id: "routine", title: "Complete your routine", sub: waiting > 0 ? waiting + " actions waiting for a yes or no" : "You've been through them all. Keep it running.", href: "#hd-routine" });
      }
      var missing = null;
      tiles.forEach(function (t) {
        if (!missing && t.state === "add" && t.key !== "quiz") missing = t.lens;
      });
      if (missing && !opts.demo) nextSteps.push({ id: "lens", title: "Add " + missing.name, sub: missing.hook + " " + missing.price + ".", href: testHref(missing.key) });
      if (retest) nextSteps.push({ id: "retest", title: "Book your retest", sub: "Opens ~" + fmtD(retest) + ". This is where the trend lines start.", href: "/pages/diagnostics-preview" });
      nextSteps = nextSteps.slice(0, 3);
      if (!nextSteps.length) nextSteps = null;
    }

    return {
      mode: readyCount === 0 ? "empty" : "dash",
      hero: {
        inRange: totals.inRange,
        attention: totals.attention,
        lensesIn: readyCount,
        lensesTotal: tiles.length,
        updated: latest ? fmtD(latest) : null
      },
      nextUp: nextUp,
      tiles: tiles,
      ai: {
        has: !!aiRaw,
        assessment: aiRaw && aiRaw.overallAssessment ? String(aiRaw.overallAssessment) : null,
        reviewed: !!(aiRaw && aiRaw.reviewedBy),
        overall: overallScore != null ? { score: overallScore, trend: (aiRaw && typeof aiRaw.overallTrend === "number") ? aiRaw.overallTrend : null } : null,
        bioChips: bioChips,
        rings: rings,
        insights: insights,
        insightsMore: insightsMore,
        insightsQuiet: insightsQuiet,
        routine: routine,
        plan: plan,
        index: mIndex,
        heroLine: heroLine,
        verdict: verdict,
        focusRing: focusRing,
        nextSteps: nextSteps,
        retestMonth: retest ? MONTHS[retest.getMonth()] : null
      }
    };
  }

  /* ===================== Wave 1: two-point trend sparkline =====================
     Renders only when a prior measurement genuinely exists in the data. A customer
     with a single test never sees an invented line: they keep the existing
     "this is where the trend lines start" treatment instead. */
  function sparkHTML(from, to, unit, betterDown, whenISO) {
    var a = parseFloat(from), b = parseFloat(to);
    if (isNaN(a) || isNaN(b)) return "";
    var better = betterDown ? (b < a) : (b > a);
    var same = b === a;
    /* Two points are not a trend, and a 34 by 12 line pretending to be one is a
       gesture at a chart rather than a chart. The data grammar says: draw a real
       trend at 96 by 28 with three or more points, or print the delta as type.
       Until a third reading exists, this prints the delta as type. */
    var col = same ? ST.none : (better ? ST.optimal : ST.watch);
    var delta = Math.round((b - a) * 100) / 100;
    var d = whenISO ? parseDate(whenISO) : null;
    var h = '<span class="spark">';
    h += '<b class="' + (delta < 0 ? "dn" : "up") + '" style="color:' + col + '">' + (same ? "" : icon("arrow-up-right", 14)) +
      (delta > 0 ? "+" : "") + delta + (unit ? esc(unit) : "") + "</b>";
    h += '<span class="sfrom">from ' + esc(String(from)) + (unit ? esc(unit) : "") + (d ? " on " + esc(fmtD(d)) : " at your last test") + "</span>";
    h += "</span>";
    return h;
  }

  /* Wave 1: per-test prior reading, if the customer actually has one. */
  function tileSpark(t) {
    var d = t.data || {};
    var w = d.prevDate || null;
    switch (t.key) {
      case "dexa":   return d.prevBodyFat != null && d.bodyFat != null ? sparkHTML(d.prevBodyFat, d.bodyFat, "%", true, w) : "";
      case "vo2max": return d.prevVo2max != null && d.vo2max != null ? sparkHTML(d.prevVo2max, d.vo2max, "", false, w) : "";
      case "omega3": return d.prevIndex != null && d.index != null ? sparkHTML(d.prevIndex, d.index, "%", false, w) : "";
      case "bioage": return d.prevBioAge != null && d.bioAge != null ? sparkHTML(d.prevBioAge, d.bioAge, "", true, w) : "";
    }
    return "";
  }

  /* ===================== tile renderers ===================== */
  function keyStat(t) {
    var d = t.data || {};
    switch (t.key) {
      case "blood":
        if (t.counts && t.counts.attention > 0) return { b: String(t.counts.attention), cls: "a", label: "need attention" };
        if (t.counts) return { b: String(t.counts.inRange), cls: "g", label: "in range" };
        return { b: "Ready", cls: "", label: "" };
      case "dexa":
        if (d.bodyFat != null) return { b: d.bodyFat + "%", cls: "", label: "body fat" };
        break;
      case "gut":
        if (d.score != null) return { b: String(d.score), cls: "", label: "/ 100 gut score" };
        break;
      case "dna":
        if (d.traits != null) return { b: String(d.traits), cls: "", label: "traits mapped" };
        break;
      case "cortisol":
        /* the waking rise is only good news inside its expected window. When the
           lens carries an attention marker the tile has to say so, rather than
           printing the number in neutral black like a settled result. */
        if (d.car != null) {
          var cortAttn = !!(t.counts && t.counts.attention > 0);
          return { b: String(d.car), cls: cortAttn ? "a" : "g", label: cortAttn ? "waking rise, below expected" : "waking response" };
        }
        break;
      case "bioage":
        if (d.bioAge != null && d.chronoAge != null) {
          var delta = Math.round((d.bioAge - d.chronoAge) * 10) / 10;
          var s = (delta > 0 ? "+" : "") + delta + " yrs";
          return { b: s, cls: delta <= 0 ? "g" : "a", label: d.pace != null ? "pace " + d.pace : "vs calendar age" };
        }
        break;
      case "omega3":
        if (d.index != null) return { b: d.index + "%", cls: (d.index < 8 ? "a" : "g"), label: d.note || "omega-3 index" };
        break;
      case "female":
        if (t.counts) return { b: String(t.counts.inRange), cls: "g", label: "of " + t.counts.total + " in range" };
        break;
      case "cac":
        if (d.score != null) return { b: String(d.score), cls: (d.score < 100 ? "g" : "a"), label: d.label || "calcium score" };
        break;
      case "vo2max":
        if (d.vo2max != null) return { b: String(d.vo2max), cls: "g", label: d.fitnessAge != null ? "fitness age " + d.fitnessAge : "ml/kg/min" };
        break;
      case "quiz":
        return { b: "Active", cls: "", label: "profile" };
    }
    if (t.counts) return { b: String(t.counts.inRange), cls: "g", label: "in range" };
    return { b: "Ready", cls: "", label: "" };
  }

  function miniDonut(counts) {
    var total = counts.total || (counts.inRange + counts.attention);
    var CIRC = 182.2; /* r=29 */
    var segs = [];
    if (counts.inRange) segs.push([counts.inRange, ST.optimal]);
    if (counts.attention) segs.push([counts.attention, ST.attn]);
    var gap = segs.length > 1 ? 5 : 0;
    var avail = CIRC - gap * segs.length;
    var off = 0, arcs = "";
    segs.forEach(function (s) {
      var len = total ? (s[0] / total) * avail : 0;
      arcs += '<circle cx="37" cy="37" r="29" fill="none" stroke="' + s[1] + '" stroke-width="8" stroke-linecap="round" stroke-dasharray="' + len.toFixed(1) + " " + CIRC.toFixed(1) + '" stroke-dashoffset="' + (-off).toFixed(1) + '" transform="rotate(-90 37 37)"/>';
      off += len + gap;
    });
    return '<svg width="72" height="72" viewBox="0 0 74 74"><circle cx="37" cy="37" r="29" fill="none" stroke="#E3E0D6" stroke-width="8"/>' + arcs +
      '<text x="37" y="41" text-anchor="middle" font-size="15" font-weight="300" fill="#0E1610" font-family="Alexandria,sans-serif">' + total + "</text></svg>";
  }

  function readyViz(t, ks) {
    var d = t.data || {};
    if (t.key === "blood" && t.counts) return { html: miniDonut(t.counts), big: null };
    if (t.key === "quiz") {
      var chips = (d.goals || []).slice(0, 2).map(function (g) { return '<span class="goalchip">' + esc(g) + "</span>"; }).join("");
      return { html: '<span class="goalchips">' + chips + "</span>", big: null };
    }
    var big = "";
    switch (t.key) {
      case "dexa": big = d.bodyFat != null ? d.bodyFat + "%" : ""; break;
      case "gut": big = d.score != null ? String(d.score) : ""; break;
      case "dna": big = d.traits != null ? String(d.traits) : ""; break;
      case "cortisol": big = d.car != null ? String(d.car) : ""; break;
      case "bioage": big = d.bioAge != null ? String(d.bioAge) : ""; break;
      case "omega3": big = d.index != null ? d.index + "%" : ""; break;
      case "cac": big = d.score != null ? String(d.score) : ""; break;
      case "vo2max": big = d.vo2max != null ? String(d.vo2max) : ""; break;
      case "female": big = t.counts ? String(t.counts.total) : ""; break;
    }
    if (big === "") return { html: GLYPHS[t.key] || "", big: null };
    /* when the big number IS the key stat, it inherits the key stat's status
       colour. A number that needs attention must not read as neutral. */
    var bigCol = "#0E1610";
    if (ks && ks.b === big) {
      if (ks.cls === "a") bigCol = ST.watch;
      else if (ks.cls === "g") bigCol = ST.optimal;
    }
    return { html: '<span style="font-family:Alexandria,sans-serif;font-weight:300;font-size:36px;color:' + bigCol + ';font-variant-numeric:tabular-nums">' + esc(big) + "</span>", big: big };
  }

  function tileHTML(t, demo, uploads, opts) {
    var L = t.lens;
    var h = "";
    if (t.state === "ready") {
      var ks = keyStat(t);
      var viz = readyViz(t, ks);
      /* Wave 1: every ready tile now resolves to a real page, the quiz included
         (it used to render a "View results" affordance on href="#"). */
      var href = lensReportHref(t.key, demo);
      var extra = t.key === "blood" ? "" : ' data-lens="' + esc(t.key) + '"';
      var dt = lensDate(t.key, t.data);
      h += '<a class="tile" href="' + href + '"' + extra + " data-state=\"ready\">";
      h += '<span class="chip ok">Ready</span>';
      h += '<span class="tname">' + esc(L.name) + "</span>";
      h += '<span class="tsub">' + (dt ? esc(fmtD(dt)) : esc(L.addSub)) + "</span>";
      h += '<span class="tviz">' + viz.html + "</span>";
      if (viz.big !== null && viz.big === ks.b) {
        /* big number already shown in the viz; key line carries only the label */
        h += '<span class="tkey"><span class="' + (ks.cls === "a" ? "klab-a" : ks.cls === "g" ? "klab-g" : "") + '">' + esc(ks.label || "") + "</span></span>";
      } else {
        h += '<span class="tkey"><b class="' + ks.cls + '">' + esc(ks.b) + "</b>" + (ks.label ? "<span>" + esc(ks.label) + "</span>" : "") + "</span>";
      }
      h += tileSpark(t);
      /* v3: blood tile opens the compact marker browser when findings exist */
      if (t.key === "blood" && t.data && isArr(t.data.findings) && t.data.findings.length) {
        h += '<span class="view-link" data-bb="1">' + t.data.findings.length + " markers, view all</span>";
      } else {
        h += '<span class="view-link">View results</span>';
      }
      h += "</a>";
    } else if (t.state === "processing") {
      var d = t.data || {};
      var pct = Math.max(8, Math.min(96, parseFloat(d.progress) || 60));
      var eta = d.eta ? String(d.eta) : "soon";
      h += '<a class="tile" href="#" data-lens="' + esc(t.key) + '" data-state="processing">';
      h += '<span class="chip warn">At lab</span>';
      h += '<span class="tname">' + esc(L.name) + "</span>";
      h += '<span class="tsub">' + esc(L.addSub) + "</span>";
      h += '<span class="tviz">' + (GLYPHS[t.key] || "") + "</span>";
      h += '<span class="tkey"><b>' + esc(eta === "soon" ? "Soon" : "~" + eta) + "</b><span>results</span></span>";
      h += '<span class="prog"><i style="width:' + pct + '%"></i></span>';
      h += "</a>";
    } else {
      /* v5: image-driven card, anchored straight to its card on the selling page */
      var addHref = t.key === "quiz" ? "/pages/wellness-quiz" : testHref(t.key);
      h += '<a class="tile add" href="' + addHref + '" data-lens="' + esc(t.key) + '" data-state="add">';
      h += '<span class="tphoto">' + (SCENES[t.key] ? '<img src="' + SCENES[t.key] + '" alt="" loading="lazy">' : "") + "</span>";
      h += '<span class="tbody">';
      h += '<span class="tname">' + esc(L.name) + "</span>";
      h += '<span class="hook">' + esc(L.hook) + "</span>";
      if (t.key === "quiz") {
        h += '<span class="tkey"><span class="tprice">' + esc(L.price) + '</span><span class="price">Take the quiz</span></span>';
      } else {
        h += '<span class="tkey"><span class="tprice">' + esc(L.price) + '</span><span class="price">Get the test</span></span>';
      }
      /* v4: quiet second path. Once an upload is in review, the line becomes a chip. */
      if (t.key !== "quiz") {
        if (uploads && uploads[t.key]) h += '<span class="upchip">Upload in review</span>';
        else h += '<span class="upl-or" data-upload="' + esc(t.key) + '">or upload your results</span>';
      }
      h += "</span></a>";
      /* v7: the zero state is a stranger's first screen, so its cards carry the
         same "who is this for" guidance the purchase page carries. The strongest
         line shows; the rest is one tap away, because three lines in every card
         of a ten card grid is a wall, not guidance. */
      if (opts && opts.who && WHO[t.key]) h = '<div class="tilewrap" data-lens="' + esc(t.key) + '">' + h + whoHTML(t.key) + "</div>";
    }
    return h;
  }

  /* The fit copy for one lens, rendered for a small card. Word for word the
     purchase page's lines, in the purchase page's order, never reworded here. */
  function whoHTML(key) {
    var w = WHO[key];
    if (!w) return "";
    var rest = w.lines.slice(1);
    var h = '<div class="twho">';
    h += '<span class="twholbl">' + esc(w.label) + "</span>";
    h += '<p class="twho1">' + esc(w.lines[0]) + "</p>";
    if (rest.length || w.not) {
      h += '<button type="button" class="twhotog" data-who="' + esc(key) + '" aria-expanded="false" aria-controls="hd-who-' + esc(key) + '">More on fit</button>';
      h += '<div class="twhorest" id="hd-who-' + esc(key) + '" hidden>';
      if (rest.length) {
        h += "<ul>";
        rest.forEach(function (l) { h += "<li>" + esc(l) + "</li>"; });
        h += "</ul>";
      }
      if (w.not) h += '<p class="twhonot">' + esc(w.not) + "</p>";
      h += "</div>";
    }
    h += "</div>";
    return h;
  }

  /* ===================== ring SVG (animated via .pre class + CSS transition) ===================== */
  function ringSVG(size, r, stroke, score, color, track) {
    var circ = 2 * Math.PI * r;
    var len = Math.max(0, Math.min(100, score)) / 100 * circ;
    var c = size / 2;
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + " " + size + '">' +
      '<circle cx="' + c + '" cy="' + c + '" r="' + r + '" fill="none" stroke="' + track + '" stroke-width="' + stroke + '"/>' +
      '<circle class="rv" cx="' + c + '" cy="' + c + '" r="' + r + '" fill="none" stroke="' + color + '" stroke-width="' + stroke + '" stroke-linecap="round"' +
      ' stroke-dasharray="' + len.toFixed(1) + " " + circ.toFixed(1) + '" stroke-dashoffset="0" style="--full:' + len.toFixed(1) + '"/></svg>';
  }
  /* The status ramp, deliberately darker and browner than the action colour so
     that #F89A1C stays the single most saturated thing on any screen and a
     status can never read as a button. */
  var ST = { optimal: "#2F7D5C", range: "#5C7A66", watch: "#8A6A2E", attn: "#A8552F", none: "#8C9990", track: "#E3E0D6" };
  function ringColor(score) {
    if (score >= 80) return ST.optimal;
    if (score >= 65) return ST.range;
    return ST.attn;
  }

  var GREETS = ["Good morning", "Good afternoon", "Good evening"];
  function greeting(hour) {
    var g = hour < 12 ? GREETS[0] : hour < 18 ? GREETS[1] : GREETS[2];
    return g;
  }

  /* ===================== section renderers =====================
     The hero is direction C's shell carrying direction B's content: no slab and
     no card, typography and hairlines only, the conclusion stated as the
     headline, and the one number of the product set at display scale in the
     brand face rather than at 33px inside a ring. */
  function renderHero(model, firstName, demo, hour) {
    var hero = model.hero, ai = model.ai;
    var h = '<div class="hero">';
    /* Each segment is one unbreakable unit and carries its own leading dot, so at
       390 the row wraps between segments instead of mid-phrase and no separator
       is ever left stranded at the end of a line.
       "Latest result" not "Updated": the date is the newest test in the picture,
       not the day the page was built.
       v8: a name in a micro uppercase eyebrow is a label, not a greeting, so
       the greeting gets its own line and the eyebrow does provenance only. */
    var greetLine = (ai.verdict && firstName) ? greeting(hour) + ", " + firstName + "." : "";
    var eySegs = greetLine ? [] : [firstName ? esc(firstName) : "Your health dashboard"];
    if (demo) eySegs.push("Sample data");
    if (hero.updated) eySegs.push("Latest result " + esc(hero.updated));
    if (!eySegs.length) eySegs.push("Your health dashboard");
    h += '<div class="eyebrow">' + eySegs.map(function (g, i) {
      return '<span class="ey">' + (i ? '<i class="dot"></i>' : "") + g + "</span>";
    }).join("") + "</div>";

    /* two wrappers: on mobile they are plain blocks and change nothing, on desktop
       they become the narrative column and the numbers column. */
    h += '<div class="hero-copy">';
    if (greetLine) h += '<p class="hgreet">' + esc(greetLine) + "</p>";
    /* The verdict, as a headline. The named system is set in the status ink,
       which is a colour of state: it is never the action colour. */
    if (ai.verdict) {
      h += "<h1>" + esc(ai.verdict.heldText) +
        (ai.verdict.focus ? "<em>" + esc(ai.verdict.focus) + "</em>" : "") +
        esc(ai.verdict.tailText) + "</h1>";
    } else {
      h += "<h1>" + esc(greeting(hour)) + (firstName ? ", " + esc(firstName) : "") + ".</h1>";
    }

    /* One sentence under the headline, not fifty-eight words. The rest of the
       narrative is what Key insights is for. */
    if (ai.has && ai.assessment) {
      h += '<p class="assess">' + esc(firstSentence(ai.assessment)) + "</p>";
    } else if (ai.heroLine) {
      h += '<p class="lead">' + esc(ai.heroLine) + "</p>";
    } else {
      h += '<p class="lead">This is where all your results live, and what to do about them.</p>';
    }
    h += "</div>";

    h += '<div class="hero-figures">';
    if (ai.overall) {
      h += '<div class="heroscore"><span class="sv">' + ai.overall.score + "</span>";
      h += '<span class="sm"><span class="k t-micro">Overall</span>';
      if (ai.overall.trend != null) {
        var up = ai.overall.trend >= 0;
        h += '<span class="trendchip' + (up ? "" : " dn") + '">' + icon("arrow-up-right", 15) +
          (up ? "+" : "") + ai.overall.trend + " since your last test</span>";
      }
      h += "</span></div>";
    }

    /* The in-range split, drawn on the one track grammar the whole product
       uses. It replaces the two boxed figures that used to sit beside the ring. */
    var heroMarks = (hero.inRange || 0) + (hero.attention || 0);
    if (heroMarks) {
      var pctIn = Math.round(1000 * hero.inRange / heroMarks) / 10;
      h += '<div class="hnums"><div class="htrack"><i style="width:' + pctIn + '%"></i></div>';
      h += '<div class="hleg"><span><b>' + hero.inRange + "</b> in range</span>" +
        '<span><b>' + hero.attention + "</b> need attention</span></div></div>";
    }

    if (ai.bioChips) {
      h += '<div class="biochips"><span class="biochip">BioAge <b>' + esc(String(ai.bioChips.bioAge)) + "</b></span>" +
        '<span class="biochip">' + esc(ai.bioChips.deltaText) + "</span></div>";
    }

    h += "</div>"; /* .hero-figures */

    /* v8: seven stacked footnotes stood between the headline naming the system
       and the card showing it. Now two disclosures, nothing deleted: the promise
       is the body of the AI badge, the scope of the counts the body of the
       score definition. */
    h += '<div class="hero-aside">';
    if (ai.has && ai.assessment) {
      h += '<details class="aidef"><summary>' +
        '<span class="ai-badge"><svg width="10" height="10" viewBox="0 0 10 10"><circle cx="5" cy="5" r="4" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="5" cy="5" r="1.4" fill="currentColor"/></svg>' +
        (ai.reviewed ? "AI analysis &middot; reviewed by your physician" : "AI-generated &middot; awaiting physician review") + "</span></summary>";
      /* shared promise line: byte-identical on the dashboard, the report engine and the blood report */
      h += '<p class="ai-promise">A licensed physician reads every AI summary before it reaches you, and can edit or reject it.</p>';
      h += "</details>";
    }

    /* Wave 1: the lead number carries its own definition; v8 adds the scope. */
    if (ai.overall) {
      h += '<details class="hdef"><summary>What\'s my overall score?</summary>' +
        "<p>It's the share of your measured markers that sit in their healthy range, and nothing more than that.</p>";
      /* the hero counts every marker from every test, while each report counts
         only its own. Saying so stops the hero and the blood browser reading as
         a contradiction when their numbers differ. */
      if (heroMarks) {
        h += '<p class="hscope">' + heroMarks + " markers, counted across every test you've taken. Each report only counts its own.</p>";
      }
      h += "</details>";
    }
    h += "</div>"; /* .hero-aside */
    h += "</div>"; /* .hero */
    return h;
  }

  /* The assessment used to run to fifty-eight words above the fold. One
     sentence earns the space; the rest of the narrative lives in Key insights,
     which is what that section is for. */
  function firstSentence(s) {
    var t = String(s || "").trim();
    var m = t.match(/^[\s\S]*?[.!?](?=\s|$)/);
    return m ? m[0].trim() : t;
  }

  /* ===================== systems: focus block + ledger =====================
     Direction B's move, in direction C's material. The one system that needs
     moving gets a real focus card naming its drivers with their values and a
     single primary action; the rest become a quiet L1 inset ledger with the
     value and its delta right-aligned in tabular figures. Six competing cards
     become one card and a list.
     Every row keeps the .rcard hooks the drill-down, the tour and the harness
     already use, so the machinery underneath is untouched. */
  function renderRings(ai, demo) {
    if (!ai.rings || !ai.rings.length) return "";
    var focus = ai.focusRing;
    var focusIdx = focus ? ai.rings.indexOf(focus) : -1;
    var h = '<div class="sect" id="hd-systems">';
    h += '<div class="h2row"><span class="h2 t-dm">Your systems</span><span class="h2sub">' + ai.rings.length + ' scored</span></div>';
    /* v8: nothing between the heading and the evidence; the hint opens the ledger */
    if (focus) h += focusHTML(ai, focus, focusIdx, demo);

    h += '<p class="secthint">One score for each part of your body, out of 100. Tap a ring to see the markers behind it and what\'s pulling it down.</p>';

    h += '<div class="ledger">';
    ai.rings.forEach(function (r, i) {
      if (i === focusIdx) return;
      var warn = r.label === "Pay attention";
      var d = r.trend;
      h += '<button type="button" class="lrow rcard' + (warn ? " warn" : "") + '" data-ring="' + i + '" aria-expanded="false" aria-controls="hd-rpanel">';
      h += '<span class="lring">' + ringSVG(28, 11, 4, r.score, ringColor(r.score), ST.track) + "</span>";
      h += '<span class="ln">' + esc(r.system) + '<span class="ls"> ' + esc(r.label) + "</span></span>";
      h += '<span class="lv">' + r.score + "</span>";
      h += '<span class="ld' + (d == null ? " flat" : d < 0 ? " dn" : d === 0 ? " flat" : "") + '">' +
        (d == null ? "" : (d > 0 ? "+" : "") + d) + "</span>";
      h += "</button>";
    });
    h += "</div>";
    h += '<div class="rpanel" id="hd-rpanel"></div>';
    /* Wave 1: one line saying what a system score actually is. */
    h += '<details class="hdef light"><summary>What\'s a system score?</summary>' +
      "<p>It's the same idea for one system at a time. The share of that system's markers currently in range, out of 100. " +
      "Optimal is 92 and above, Strong is 80 to 91, Fair is 65 to 79, and anything under 65 is worth paying attention to.</p></details>";
    h += "</div>";
    return h;
  }

  /* The focus block. Two real drivers with their values on the one bar, one
     filled action, one tertiary link. */
  function focusHTML(ai, ring, idx, demo) {
    var rows = ringContributors(ring, ai.index || []);
    var warnRows = rows.filter(function (m) { return m.status === "warn"; });
    var drivers = (warnRows.length ? warnRows : rows).slice(0, 2);
    var h = '<div class="focus" id="hd-focus">';
    h += '<span class="fk t-micro">Needs attention</span>';
    h += '<button type="button" class="focusrow rcard" data-ring="' + idx + '" aria-expanded="false" aria-controls="hd-rpanel">' +
      '<span class="fname">' + esc(ring.system) + ',</span><span class="fscore">' + ring.score + "</span></button>";
    var why = SYSTEM_EXPLAIN[ring.system];
    if (why) h += '<p class="fwhy">' + esc(why) + "</p>";
    if (drivers.length) {
      h += '<div class="fbars">';
      drivers.forEach(function (m) {
        var warn = m.status === "warn";
        h += '<div class="fbar' + (warn ? " warn" : "") + '">';
        h += '<div class="flab"><span class="m">' + esc(m.name) + '</span><span class="v">' +
          esc(String(m.value == null ? "" : m.value)) + (m.unit ? '<span class="unit">' + esc(m.unit) + "</span>" : "") + "</span></div>";
        var g = bandGeom(m.value, m.range);
        if (g) {
          h += '<div class="cband"><span class="axis"></span>' +
            '<span class="zone" style="left:' + g.zoneL + "%;width:" + g.zoneW + '%"></span>' +
            '<span class="dot" style="left:' + g.dot + '%"></span></div>';
        }
        h += "</div>";
      });
      h += "</div>";
    }
    h += '<div class="fact"><a class="hd-pill" href="#hd-routine" data-sys-actions="' + esc(ring.system) + '">See the plan</a>';
    if (rows.length) {
      h += '<button type="button" class="btn3 rcard" data-ring="' + idx + '" aria-expanded="false" aria-controls="hd-rpanel">All ' +
        rows.length + " markers</button>";
    }
    h += "</div></div>";
    return h;
  }

  /* ===================== Wave 1: zone band geometry =====================
     The old contributor bar drew a left-anchored fill whose length read as
     magnitude, with no endpoints and no zone. This computes the same grammar the
     marker reports use: an axis, a shaded healthy zone, a dot for the customer's
     value, and the printed endpoints. Self-contained on purpose.
     Returns null when the range cannot be parsed, so callers can fall back. */
  function bandGeom(value, range) {
    var v = parseFloat(String(value == null ? "" : value).replace(/[^0-9.\-]/g, ""));
    if (isNaN(v)) return null;
    var r = String(range || "").trim();
    if (!r) return null;
    var lo = null, hi = null, loLab = null, hiLab = null, axLo, axHi;

    var m = r.match(/(-?\d+(?:\.\d+)?)\s*(?:-|to)\s*(-?\d+(?:\.\d+)?)/);
    if (m) {
      lo = parseFloat(m[1]); hi = parseFloat(m[2]);
      if (!(hi > lo)) return null;
      var pad = (hi - lo) * 0.55;
      axLo = lo - pad; axHi = hi + pad;
      loLab = m[1]; hiLab = m[2];
    } else {
      m = r.match(/^([<>])=?\s*(-?\d+(?:\.\d+)?)/);
      if (!m) return null;
      var lim = parseFloat(m[2]);
      if (m[1] === "<") {
        lo = null; hi = lim;
        axLo = Math.min(0, lim); axHi = lim + Math.abs(lim || 1) * 0.6;
        hiLab = m[2];
      } else {
        lo = lim; hi = null;
        axLo = Math.max(0, lim - Math.abs(lim || 1) * 0.6);
        if (lim <= 0) axLo = lim - Math.abs(lim || 1) * 0.6;
        axHi = lim + Math.abs(lim || 1) * 0.6;
        loLab = m[2];
      }
    }
    var span = axHi - axLo;
    if (!(span > 0)) return null;
    /* the dot may sit outside the axis when a value is far out of range: clamp it
       so it stays visible, and keep the printed value as the honest number. */
    function pct(x) { return Math.max(0, Math.min(100, ((x - axLo) / span) * 100)); }
    var zL = lo == null ? 0 : pct(lo);
    var zR = hi == null ? 100 : pct(hi);
    return {
      zoneL: Math.round(zL * 10) / 10,
      zoneW: Math.round((zR - zL) * 10) / 10,
      dot: Math.round(Math.max(2, Math.min(98, pct(v))) * 10) / 10,
      loLabel: loLab, hiLabel: hiLab
    };
  }

  /* Wave 1: healthy-zone label under the band, in plain words. */
  function bandZoneText(g) {
    if (g.loLabel != null && g.hiLabel != null) return g.loLabel + " to " + g.hiLabel;
    if (g.hiLabel != null) return "under " + g.hiLabel;
    if (g.loLabel != null) return "over " + g.loLabel;
    return "healthy range";
  }

  /* One axis tick, centred on its own position, pulled inside the track at the
     extremes so it can never be clipped. */
  function tickHTML(label, pos) {
    if (label == null || label === "") return "";
    var p = Math.max(0, Math.min(100, pos));
    var style = "left:" + (Math.round(p * 10) / 10) + "%";
    if (p <= 6) style += ";transform:none";
    else if (p >= 94) style += ";transform:translateX(-100%)";
    return '<span class="zt" style="' + style + '">' + esc(label) + "</span>";
  }

  /* v3 row, Wave 1 visualization: zone band with the customer's dot on it. */
  function cbarHTML(m) {
    var warn = m.status === "warn";
    var h = '<div class="cbar' + (warn ? " warn" : "") + '">';
    h += '<div class="cl"><span class="m">' + esc(m.name) + (warn ? '<span class="cst">Outside range</span>' : "") + '</span><span class="v">' + esc(String(m.value == null ? "" : m.value)) + (m.unit ? "<i>" + esc(m.unit) + "</i>" : "") + "</span></div>";
    var g = bandGeom(m.value, m.range);
    if (g) {
      h += '<div class="cband"><span class="axis"></span>' +
        '<span class="zone" style="left:' + g.zoneL + "%;width:" + g.zoneW + '%"></span>' +
        '<span class="dot" style="left:' + g.dot + '%"></span>' +
        /* the endpoint labels are the healthy band's own bounds, so they sit at
           the band's edges on the scale, not at the ends of the track. */
        tickHTML(g.loLabel, g.zoneL) + tickHTML(g.hiLabel, g.zoneL + g.zoneW) +
        "</div>";
      h += '<div class="cends"><span class="zl">healthy ' + esc(bandZoneText(g)) + (m.unit ? " " + esc(m.unit) : "") + "</span></div>";
    } else if (m.range) {
      h += '<div class="cends"><span class="zl">healthy range ' + esc(m.range) + "</span></div>";
    }
    /* The status word once per row, not the same sentence repeated down the
       whole panel. The panel says what the plan does about them, once. */
    h += "</div>";
    return h;
  }

  /* v3: inline drill-down panel for one system ring */
  function ringPanelHTML(ring, index, demo) {
    var rows = ringContributors(ring, index || []);
    var warnCount = rows.filter(function (m) { return m.status === "warn"; }).length;
    var warnLab = ring.label === "Pay attention";
    var h = '<div class="rphead"><b>' + ring.score + '</b><span class="rpname">' + esc(ring.system) + '</span><span class="rplab' + (warnLab ? " warn" : "") + '">' + esc(ring.label) +
      (ring.trend != null ? " &middot; " + (ring.trend >= 0 ? "+" : "") + ring.trend + " since your last test" : "") + "</span></div>";
    if (typeof ring.trend === "number" && typeof ring.score === "number" && ring.trend !== 0) {
      h += sparkHTML(ring.score - ring.trend, ring.score, "", false, null);
    }
    if (rows.length) {
      h += '<div class="cbars">';
      rows.slice(0, 14).forEach(function (m) { h += cbarHTML(m); });
      h += "</div>";
      if (rows.length > 14) h += '<div class="rpwhy">' + (rows.length - 14) + " more markers feed this score, further down.</div>";
    } else if (ring.drivers && ring.drivers.length) {
      h += '<div class="rpwhy">Driven by ' + ring.drivers.map(esc).join(", ") + ".</div>";
    }
    var why = SYSTEM_EXPLAIN[ring.system];
    if (why) h += '<div class="rpwhy">' + esc(why) +
      (warnCount ? " " + warnCount + " of " + rows.length + " markers sit outside their range, and your plan targets each of them." : "") + "</div>";
    h += '<div class="rplinks">';
    h += '<a href="#hd-routine" data-sys-actions="' + esc(ring.system) + '">See your ' + esc(ring.system) + " actions</a>";
    var lens = (ring.lenses && ring.lenses.length) ? ring.lenses[0] : null;
    if (lens && lens !== "quiz") {
      var href = lens === "blood" ? "/pages/my-recommendations" + (demo ? "?demo=1" : "") : "/pages/test-report?lens=" + lens + (demo ? "&demo=1" : "");
      h += '<a href="' + href + '">Open report</a>';
    }
    h += "</div>";
    return h;
  }

  /* v3: value chip for one marker inside an insight card */
  function vchipHTML(m) {
    var h = '<span class="vchip"><span class="vn">' + esc(m.name) + "</span>";
    h += '<span class="vv">' + esc(String(m.value == null ? "" : m.value)) + (m.unit ? "<i>" + esc(m.unit) + "</i>" : "");
    if (typeof m.delta === "number") {
      var up = m.delta >= 0;
      h += '<span class="vd ' + (up ? "up" : "dn") + '">' + (up ? "+" : "") + m.delta + " vs last</span>";
    }
    h += "</span>";
    if (m.target) h += '<span class="vt">target ' + esc(String(m.target)) + "</span>";
    h += "</span>";
    return h;
  }

  function insightCardHTML(c, demo) {
    var h = '<div class="icard' + (c.severity === "attention" ? " attn" : "") + '">';
    h += '<div class="ititle">' + esc(c.title) + "</div>";
    h += '<div class="ibody">' + esc(c.narrative) + "</div>";
    if (c.markers && c.markers.length) {
      h += '<div class="ichips">';
      c.markers.forEach(function (m) { h += vchipHTML(m); });
      h += "</div>";
    }
    if ((c.systems && c.systems.length) || (c.lenses && c.lenses.length)) {
      h += '<div class="isys">';
      if (c.systems && c.systems.length) {
        h += '<span class="isk">' + (c.severity === "attention" ? "Affects" : "Supports") + "</span>";
        c.systems.forEach(function (s) { h += '<a class="syschip" href="#hd-systems" data-sys-ring="' + esc(s) + '">' + esc(s) + "</a>"; });
      }
      /* Wave 1: render the display name, never the machine key, and deep-link into
         that test's report so the chip is an affordance rather than decoration. */
      (c.lenses || []).forEach(function (l) {
        var nm = lensName(l);
        var href = lensReportHref(l, !!demo);
        if (href) h += '<a class="lenschip" href="' + href + '">' + esc(nm) + "</a>";
        else h += '<span class="lenschip">' + esc(nm) + "</span>";
      });
      h += "</div>";
    }
    h += "</div>";
    return h;
  }

  function renderInsights(ai, demo) {
    if (ai.insights && ai.insights.length) {
      var h = '<div class="sect" id="hd-insights"><div class="h2row"><span class="h2">Key insights</span><span class="h2sub">' + ai.insights.length + (ai.insightsMore ? " of " + (ai.insights.length + ai.insightsMore.length) : "") + " from your data</span></div>";
      h += '<p class="secthint">What turns up when your results get read together instead of one at a time. Tap a system tag to jump to its ring, or a test name to open that report.</p>';
      h += '<div class="icards">';
      ai.insights.forEach(function (c) { h += insightCardHTML(c, demo); });
      h += "</div>";
      if (ai.insightsMore && ai.insightsMore.length) {
        /* overflow grouped by primary system */
        var groups = {}, order = [];
        ai.insightsMore.forEach(function (c) {
          var g = (c.systems && c.systems[0]) || "More";
          if (!groups[g]) { groups[g] = []; order.push(g); }
          groups[g].push(c);
        });
        h += '<button type="button" class="imore" id="hd-imore" aria-expanded="false">View all insights (' + ai.insightsMore.length + " more)</button>";
        h += '<div class="ioverflow" id="hd-ioverflow">';
        order.forEach(function (g) {
          h += '<div class="igroup">' + esc(g) + "</div>";
          h += '<div class="icards">';
          groups[g].forEach(function (c) { h += insightCardHTML(c, demo); });
          h += "</div>";
        });
        h += "</div>";
      }
      h += "</div>";
      return h;
    }
    if (ai.insightsQuiet) {
      return '<div class="sect" id="hd-insights"><div class="h2row"><span class="h2">Key insights</span></div>' +
        '<div class="icard quiet"><svg width="18" height="18" viewBox="0 0 18 18" style="flex:0 0 auto;margin-top:1px"><circle cx="9" cy="9" r="7.2" fill="none" stroke="#5C7A66" stroke-width="1.6"/><path d="M9 5.6 v3.8 l2.6 1.6" fill="none" stroke="#5C7A66" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        "<p>Your combined AI summary shows up once your physician reviews your next result. Every test you add gives it more to work with.</p></div></div>";
    }
    return "";
  }

  function stackCountText(st) { return st.active + " of " + st.total + " active"; }

  function actionRowHTML(a, status, index) {
    var h = '<div class="arow' + (status === "rejected" ? " rejected" : "") + '" data-arow="' + esc(a.id) + '">';
    h += '<div class="amain">';
    h += '<div class="at"><b>' + esc(a.title) + "</b>";
    if (a.frequency) h += '<span class="freq">' + esc(a.frequency) + "</span>";
    /* v3: impact chip (explicit or derived from out-of-range targeting) */
    if (!a.care) {
      var imp = impactOf(a, index || []);
      h += '<span class="impact' + (imp === "high" ? "" : " med") + '">' + (imp === "high" ? "High impact" : "Medium impact") + "</span>";
    }
    h += '<span class="srcchip ' + (a.source === "physician" ? "phys" : "ai") + '">' + (a.source === "physician" ? "Physician" : "AI") + "</span>";
    h += "</div>";
    if (a.why) h += '<div class="awhy">' + esc(a.why) + "</div>";
    if (a.improves && a.improves.length) {
      h += '<div class="aimp">';
      a.improves.forEach(function (im) {
        h += '<span class="impchip">' + esc(im.marker) + " " + esc(String(im.current)) + ' <i> to  ' + esc(String(im.target)) + "</i></span>";
      });
      h += "</div>";
    }
    /* v3: expandable concrete steps, graceful fallback when absent */
    if (a.steps && a.steps.length) {
      h += '<button type="button" class="stepsbtn" data-steps-btn="' + esc(a.id) + '" aria-expanded="false">Steps (' + a.steps.length + ")</button>";
      h += '<ul class="steps" data-steps="' + esc(a.id) + '">';
      a.steps.forEach(function (s) { h += "<li>" + esc(s) + "</li>"; });
      h += "</ul>";
    }
    h += "</div>";
    h += '<div class="atgl">';
    h += '<button type="button" class="tglbtn yes' + (status === "accepted" ? " on" : "") + '" data-toggle="accepted" data-action-id="' + esc(a.id) + '" aria-label="Accept ' + esc(a.title) + '"><svg width="16" height="16" viewBox="0 0 16 16"><path d="M3 8.5 L6.5 12 L13 4.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    h += '<button type="button" class="tglbtn no' + (status === "rejected" ? " on" : "") + '" data-toggle="rejected" data-action-id="' + esc(a.id) + '" aria-label="Skip ' + esc(a.title) + '"><svg width="14" height="14" viewBox="0 0 14 14"><path d="M3.5 3.5 L10.5 10.5 M10.5 3.5 L3.5 10.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
    h += "</div></div>";
    return h;
  }

  function renderRoutine(ai, routineState) {
    var r = ai.routine;
    if (!r) return "";
    var h = '<div class="sect" id="hd-routine">';
    h += '<div class="h2row"><span class="h2">Your routine</span><span class="h2sub">actions that compound</span></div>';
    h += '<p class="secthint">What your results actually ask you to do. Open a stack, accept what you\'ll keep, skip the rest. Only what you keep counts towards the projection below.</p>';
    /* v3: goal anchor line */
    if (r.goals && r.goals.length) {
      h += '<div class="goalline">Built around your goals: <b>' + r.goals.map(function (g) { return esc(String(g).toLowerCase()); }).join(", ") + "</b>.</div>";
    }
    h += '<div class="stacks">';
    r.stacks.forEach(function (st) {
      h += '<button type="button" class="stackcard' + (st.id === "care" ? " care" : "") + '" data-stack="' + esc(st.id) + '" aria-expanded="false">';
      h += '<span class="sname">' + esc(st.title) + "</span>";
      if (st.tagline) h += '<span class="stag">' + esc(st.tagline) + "</span>";
      h += '<span class="scount" data-stack-count="' + esc(st.id) + '">' + stackCountText(st) + "</span>";
      h += "</button>";
    });
    h += "</div>";
    r.stacks.forEach(function (st) {
      h += '<div class="actions" data-actions="' + esc(st.id) + '">';
      st.actions.forEach(function (a) {
        h += actionRowHTML(a, actionStatus(a, routineState), ai.index);
      });
      h += "</div>";
    });

    /* v3: the bridge. "Where your plan takes you" replaces the separate
       improves panel + outlook card: projection bars per system, computed from
       the active actions and recomputed live on toggle (see computeOutlook). */
    h += '<div class="plansect" id="hd-plan">' + planInnerHTML(ai) + "</div>";
    h += "</div>";
    return h;
  }

  function planInnerHTML(ai) {
    var plan = ai.plan;
    var h = '<div class="pk">Where your plan takes you</div>';
    if (!plan || !plan.bars.length) {
      h += '<div class="otitle">Accept actions above and this becomes a projection.</div>';
      h += '<div class="oempty">Every action you accept adds expected movement to the system it targets. Nothing is active yet.</div>';
      return h;
    }
    h += '<div class="otitle">Where your active actions could move each system by ' + esc(plan.byDate || "your next retest") + ".</div>";
    h += '<p class="secthint">This is what the routine above is worth. Skip an action and it stops counting here.</p>';
    h += '<div class="obars">';
    plan.bars.forEach(function (b) {
      h += '<div class="obar">';
      /* Wave 1: two explicitly distinct segments (today in a pale tone, the
         projected gain in green) with a dark boundary between them, a delta chip,
         and a floor so a 1-point gain is still visible. */
      var gain = Math.max(0, b.to - b.from);
      var gainW = Math.max(1.5, Math.min(100, gain));
      var gainL = Math.min(b.from, 100 - gainW); /* the floor wins; the start shifts a hair */
      h += '<div class="ol"><span class="m">' + esc(b.system) + (gain > 0 ? '<span class="odelta">+' + gain + "</span>" : "") + '</span><span class="v">' + b.from + ' to <b>' + b.to + "</b> by " + esc(plan.byDate || "next retest") + "</span></div>";
      h += '<div class="otrack"><span class="oseg-now" style="width:' + b.from + '%"></span>' +
        '<span class="oseg-gain" style="left:' + gainL + "%;width:" + gainW + '%"></span></div>';
      if (b.marks && b.marks.length) {
        h += '<div class="omarks">';
        b.marks.forEach(function (e) {
          h += '<div class="omark"><span>' + esc(e.marker) + '</span><span><i class="ofrom' + (e.warn ? " warn" : "") + '">' +
            esc(String(e.from)) + "</i> to <b>" + esc(String(e.toRange)) + "</b></span></div>";
        });
        h += "</div>";
      }
      h += "</div>";
    });
    h += "</div>";
    h += '<div class="onote">These estimates come from the markers your active actions target. Real results vary. This is information, not medical advice, and your physician confirms every change.</div>';
    return h;
  }

  /* ===================== v3: blood marker browser (bottom sheet) ===================== */
  function bbRowHTML(row) {
    return '<div class="bb-row' + (row.status === "warn" ? " warn" : "") + '"><span class="d"></span><span class="n">' + esc(row.name) + '</span><span class="v">' + esc(String(row.value == null ? "" : row.value)) + (row.unit ? "<i>" + esc(row.unit) + "</i>" : "") + (row.range ? "<i>" + esc(row.range) + "</i>" : "") + "</span></div>";
  }
  function bloodBrowserHTML(findings, dateText) {
    var m = bloodBrowserModel(findings);
    var h = '<div class="bb-overlay" id="hd-bb" role="dialog" aria-label="Blood panel markers">';
    h += '<div class="bb-sheet">';
    h += '<div class="bb-head"><span class="bbt">Blood Panel</span><button type="button" class="bb-close" data-bb-close="1" aria-label="Close">&times;</button></div>';
    h += '<div class="bb-sub">' + m.total + " markers" + (dateText ? " &middot; " + esc(dateText) : "") + "</div>";
    /* v6: only the list scrolls, the head stays in the frame */
    h += '<div class="bb-scroll">';
    if (m.out.length) {
      h += '<div class="bb-bucket">Out of range <span class="n">' + m.out.length + "</span></div>";
      h += '<div class="bb-card">';
      m.out.forEach(function (r) { h += bbRowHTML(r); });
      h += "</div>";
    }
    var inCount = m.total - m.out.length;
    h += '<div class="bb-bucket">In range &middot; ' + inCount + "</div>";
    h += '<div class="bb-card">';
    m.cats.forEach(function (c, i) {
      h += '<button type="button" class="bb-cat" data-bb-cat="' + i + '" aria-expanded="false"><span class="d"></span><span class="n">' + esc(c.name) + '</span><span class="c">' + c.count + ' markers</span><span class="ar">' + icon("chevron-right", 16) + '</span></button>';
      h += '<div class="bb-rows" data-bb-rows="' + i + '">';
      c.rows.forEach(function (r) { h += bbRowHTML(r); });
      h += "</div>";
    });
    h += "</div>";
    h += "</div>"; /* .bb-scroll */
    h += "</div></div>";
    return h;
  }

  /* ===================== v4: upload your results (bottom sheet) =====================
     UI only. POSTs multipart form-data to the wellness upload endpoint:
     file (PDF/JPG/PNG, max 4MB client-side), lens, email, customerId (optional), consent "true".
     Success = 2xx + {ok:true}. Anything else renders the calm retry state.
     Successful uploads persist to localStorage hewyn_uploads_v1 as {lens: timestamp}
     so the matching add tile shows an "Upload in review" chip until results land.
     Demo mode never POSTs: submit shows a stub note instead. */
  var UPLOAD_KEY = "hewyn_uploads_v1";
  var UPLOAD_ENDPOINT = "https://hewyn-agent-assist.vercel.app/api/wellness/upload";
  var UPLOAD_MAX_BYTES = 4 * 1024 * 1024; /* Vercel rejects bodies over ~4.5MB before the route runs */

  function uploadLensName(key) {
    var name = null;
    LENSES.forEach(function (L) { if (L.key === key) name = L.name; });
    return name;
  }

  function loadUploads(storage) {
    try {
      var raw = storage && storage.getItem ? storage.getItem(UPLOAD_KEY) : null;
      var o = raw ? JSON.parse(raw) : null;
      return (o && typeof o === "object" && !isArr(o)) ? o : {};
    } catch (_) { return {}; }
  }
  function saveUpload(storage, uploads, lens) {
    uploads = (uploads && typeof uploads === "object") ? uploads : {};
    uploads[lens] = Date.now();
    try { if (storage && storage.setItem) storage.setItem(UPLOAD_KEY, JSON.stringify(uploads)); } catch (_) {}
    return uploads;
  }

  /* pure validation so the headless suite can exercise every branch */
  function validateUpload(o) {
    o = o || {};
    if (!o.lens) return { ok: false, field: "lens", msg: "Tell us which test this report is from." };
    if (!o.fileName) return { ok: false, field: "file", msg: "Choose a file to upload first." };
    if (!/\.(pdf|jpe?g|png)$/i.test(String(o.fileName))) return { ok: false, field: "file", msg: "That file type won't work here. A PDF, JPG or PNG will." };
    if (o.fileSize != null && o.fileSize > UPLOAD_MAX_BYTES) return { ok: false, field: "file", msg: "This file is over 4MB. Try exporting a smaller PDF, or email it to us and we'll add it for you." };
    if (!o.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(o.email))) return { ok: false, field: "email", msg: "Add the email you use with Hewyn so we can match your account." };
    if (!o.consent) return { ok: false, field: "consent", msg: "Tick the consent box so our team is allowed to open your file." };
    return { ok: true };
  }

  function uploadSheetHTML(opts) {
    opts = opts || {};
    var email = opts.email || "";
    var h = '<div class="bb-overlay" id="hd-up" role="dialog" aria-label="Upload your results">';
    h += '<div class="bb-sheet">';
    h += '<div class="bb-head"><span class="bbt" id="hd-up-title">Upload your results</span><button type="button" class="bb-close" data-bb-close="1" aria-label="Close">&times;</button></div>';
    h += '<div class="bb-scroll">';
    h += '<p class="up-body">Tested somewhere else? Send us the report and our physician team adds it to your dashboard.</p>';
    h += '<div class="up-field" id="hd-up-lenswrap" style="display:none">';
    h += '<label class="up-label" for="hd-up-lens">Which test is this?</label>';
    h += '<select class="up-input" id="hd-up-lens"><option value="">Choose a test</option>';
    LENSES.forEach(function (L) {
      if (L.key === "quiz") return;
      h += '<option value="' + esc(L.key) + '">' + esc(L.name) + "</option>";
    });
    h += '<option value="other">Other</option>';
    h += "</select></div>";
    h += '<div class="up-field">';
    h += '<label class="up-label" for="hd-up-file">Report file</label>';
    h += '<input class="up-file" type="file" id="hd-up-file" accept=".pdf,.jpg,.jpeg,.png">';
    h += '<div class="up-hint">PDF, JPG or PNG, up to 4MB.</div>';
    h += "</div>";
    h += '<div class="up-field" id="hd-up-emailwrap"' + (email ? ' style="display:none"' : "") + ">";
    h += '<label class="up-label" for="hd-up-email">Email</label>';
    h += '<input class="up-input" type="email" id="hd-up-email" value="' + esc(email) + '" autocomplete="email" inputmode="email" placeholder="you@example.com">';
    h += "</div>";
    h += '<label class="up-consent"><input type="checkbox" id="hd-up-consent"><span>' +
      "I'm happy for Hewyn's team to read this file and add my results to my account." + "</span></label>";
    h += '<button type="button" class="hd-pill up-submit" id="hd-up-submit" disabled>Send for review</button>';
    h += '<div class="up-status" id="hd-up-status" role="status"></div>';
    h += "</div>"; /* .bb-scroll */
    h += "</div></div>";
    return h;
  }

  function renderNextSteps(ai) {
    if (!ai.nextSteps || !ai.nextSteps.length) return "";
    var h = '<div class="sect"><div class="h2row"><span class="h2">Keep the loop going</span></div><div class="nsteps">';
    ai.nextSteps.forEach(function (s, i) {
      h += '<a class="nstep" href="' + esc(s.href) + '"><span class="nsn">' + (i + 1) + '</span><span class="nsb"><b>' + esc(s.title) + "</b><span>" + esc(s.sub) + '</span></span><span class="nsarrow">' + icon("chevron-right", 18) + '</span></a>';
    });
    h += "</div></div>";
    return h;
  }

  /* ===================== v6/v7/v8/v10: first-run welcome =====================
     Two surfaces, one state key.
     The spotlight (v7) draws coach marks over the real page, one section at a
     time. A spotlight has to scroll the page under a fixed overlay at every
     step; that is solved rather than avoided, by scrolling the target into
     place FIRST, waiting for the scroll to settle, and only then drawing the
     cutout and the card. It is the one thing on this page allowed to move:
     holdFrame and overflow-anchor:none are untouched everywhere else.

     v10 settles what the first-run sheet is for. Up to v9 it explained the
     page's three steps in prose and then offered the spotlight as a footnote
     underneath, which is the tour's job done worse: at 1280 the three steps
     laid out as three 250px columns of four-line body copy, a wall of ragged
     text, with a three-line note wrestling the buttons for the footer. The
     sheet is now an invitation and nothing else: who you are, one sentence on
     what the page is, and the choice. Take the walkthrough, or dismiss. The
     three ideas are still taught, by the spotlight, against the real sections.
     State lives in localStorage under hewyn_dash_tour_v1. A missing key, an
     unparseable value or a storage that throws all mean first visit. */
  var TOUR_KEY = "hewyn_dash_tour_v1";
  function loadTour(storage) {
    try {
      var raw = storage && storage.getItem ? storage.getItem(TOUR_KEY) : null;
      if (!raw) return { dismissed: false };
      var o = JSON.parse(raw);
      return { dismissed: !!(o && o.dismissed) };
    } catch (_) { return { dismissed: false }; }
  }
  function saveTour(storage, dismissed) {
    try { if (storage && storage.setItem) storage.setItem(TOUR_KEY, JSON.stringify({ v: 1, dismissed: !!dismissed })); } catch (_) {}
    return { dismissed: !!dismissed };
  }

  /* The welcome sheet. Five elements, in this order and no others:
       the greeting, one sentence, the walkthrough, the dismissal, the note.
     "Show me around" is the primary and is filled; "Got it" is the quiet way
     out. The sample-data line is honesty, so it stays, but it is one muted line
     under the buttons rather than a block beside them.
     The entry link is in the flow and the welcome is not, so the focus card is
     never pushed down by a panel. The link renders in both states, so the
     spotlight always has a trigger to hand focus back to. */
  function tourHTML(firstName, demo, open) {
    var h = '<div class="tourbar" id="hd-tour">';
    h += '<button type="button" class="tourlink-hit" data-tour-open="1" aria-expanded="' + (open ? "true" : "false") +
      '" aria-controls="hd-tourpanel"><span class="tourlink">How this page works</span></button>';
    if (!open) return h + "</div>";
    h += '<div class="tour-ov"><span class="tour-scrim" data-tour-dismiss="1"></span>';
    h += '<div class="bb-sheet tour-sheet" role="dialog" aria-modal="true" aria-labelledby="hd-tour-title" tabindex="-1">';
    h += '<div class="bb-head"><span></span><button type="button" class="bb-close" data-tour-dismiss="1" aria-label="Close">&times;</button></div>';
    h += '<div class="bb-scroll"><div class="hdtour" id="hd-tourpanel">';
    h += '<div class="tw" id="hd-tour-title">Welcome' + (firstName ? ", " + esc(firstName) : "") + ".</div>";
    h += '<p class="tlead">Everything you\'ve tested ends up here, next to a plan you can follow.</p>';
    h += '<div class="tfoot"><button type="button" class="trun" data-tour-run="1">Show me around</button>';
    h += '<button type="button" class="tdone" data-tour-dismiss="1">Got it</button></div>';
    h += '<p class="tnote">' + (demo
      ? "These are sample numbers for Alex, not yours."
      : "You can bring this back any time from How this page works.") + "</p>";
    h += "</div></div></div></div>"; /* .hdtour .bb-scroll .bb-sheet .tour-ov */
    return h + "</div>";
  }

  /* ===================== v7: the spotlight tour =====================
     Six stops, chosen because they are the page's actual anatomy and because
     each one teaches something a reader cannot guess by looking: that a ring is
     tappable, that accepting an action redraws the projection, that a test can
     be uploaded rather than bought. Anything that explains itself on sight is
     not a stop.
     Every stop names the element it points at. A stop whose element is not on
     this customer's page (no rings yet, no published routine) is dropped by
     resolveStops and the remaining ones are renumbered, so the card never says
     "Step 4 of 6" while pointing at nothing. */
  function tourStops() {
    return [
      { key: "hero", sel: "#hd-root .hero", pad: 8,
        title: "Where you stand",
        body: "The big number is your overall score out of 100, read from every result you've got. The line under it splits that into what's in range and what needs attention." },
      { key: "systems", sel: "#hd-systems", pad: 6,
        title: "Your systems",
        body: "One score for each part of your body, out of 100. Whichever one needs work gets its own card. Tap any row to see the markers behind that score." },
      { key: "insights", sel: "#hd-insights", pad: 6,
        title: "Key insights",
        body: "This is where separate results get read together. Each card says what we found, why it matters for you, and what to do about it." },
      { key: "routine", sel: "#hd-routine", pad: 6,
        title: "Your routine",
        body: "Open a stack and accept the actions you'll actually do. Skip the rest. Only what you accept counts towards the projection." },
      { key: "plan", sel: "#hd-plan", pad: 6,
        title: "Where your plan takes you",
        body: "These bars run each system forward on the actions you kept. Accept or skip one and they redraw straight away." },
      { key: "tests", sel: "#hd-tests", pad: 6,
        title: "Your tests",
        body: "Every result you've got, and every test still open to you. Add one, or upload results from somewhere else, and everything above redraws against the new numbers." }
    ];
  }

  /* find(sel) returns the element or null. Pure so it can be tested without a DOM. */
  function resolveStops(stops, find) {
    var live = [];
    for (var i = 0; i < stops.length; i++) {
      var el = find(stops[i].sel);
      if (el) live.push({ key: stops[i].key, sel: stops[i].sel, pad: stops[i].pad, title: stops[i].title, body: stops[i].body, el: el });
    }
    for (var j = 0; j < live.length; j++) { live[j].n = j + 1; live[j].of = live.length; }
    return live;
  }

  /* A tour with fewer than two stops is not a tour, it is a caption. */
  function canRunTour(stops) { return !!(stops && stops.length >= 2); }

  /* Which of the two surfaces a request for help should open. The spotlight is
     the default. Reduced motion gets the static explainer, which still offers
     the spotlight behind its own button for anyone who wants it. */
  function tourRoute(canRun, reduced) {
    if (!canRun) return "static";
    if (reduced) return "static";
    return "spotlight";
  }

  /* ---- geometry, all pure, all unit tested ---- */

  /* the cutout: the element's own box plus a little breathing room, clamped to
     the viewport so a target that runs off an edge still gets a valid hole */
  /* maxH exists because several sections here are taller than a phone. A cutout
     the size of the whole frame leaves nothing dimmed, so the highlight stops
     reading as a highlight. When a target overflows, the hole covers its top
     instead: the heading and the first rows, which is what the card is naming,
     and the dim still has somewhere to be. */
  function spotRect(r, pad, vw, vh, maxH) {
    pad = pad || 0;
    var x = Math.max(0, r.left - pad);
    var y = Math.max(0, r.top - pad);
    var x2 = Math.min(vw, r.left + r.width + pad);
    var y2 = Math.min(vh, r.top + r.height + pad);
    var h = Math.max(0, y2 - y);
    if (maxH && h > maxH) h = maxH;
    return { x: Math.round(x), y: Math.round(y), w: Math.round(Math.max(0, x2 - x)), h: Math.round(h) };
  }

  /* the card: under the cutout when it fits, above it when it does not, and
     always fully on screen. At 390 the card is wider than most targets, so the
     horizontal clamp does most of the work. */
  function placeTip(spot, tipW, tipH, vw, vh, gap, edge) {
    gap = gap == null ? 12 : gap;
    edge = edge == null ? 10 : edge;
    var below = spot.y + spot.h + gap;
    var above = spot.y - gap - tipH;
    var place = "below", y = below;
    if (below + tipH + edge > vh) {
      if (above >= edge) { place = "above"; y = above; }
      /* A target taller than the frame leaves room on neither side. The card
         then pins to the bottom of the frame rather than the top, because the
         top of a section is where its heading is and the heading is the thing
         the card is naming. */
      else { place = "below"; y = Math.max(edge, vh - tipH - edge); }
    }
    var x = Math.round(spot.x + spot.w / 2 - tipW / 2);
    if (x + tipW + edge > vw) x = vw - tipW - edge;
    if (x < edge) x = edge;
    /* the pointer stays over the cutout even after the card has been clamped */
    var ax = Math.round(spot.x + spot.w / 2 - x);
    ax = Math.max(16, Math.min(tipW - 16, ax));
    return { x: x, y: Math.round(y), place: place, ax: ax };
  }

  /* where the page has to be for this target to sit in a calm part of the frame,
     with the theme's sticky header cleared and room left for the card. A target
     taller than that space is simply pinned under the header. */
  function scrollTopFor(absTop, elH, vh, docH, headroom, tipRoom) {
    headroom = headroom == null ? 84 : headroom;
    tipRoom = tipRoom == null ? 190 : tipRoom;
    var free = vh - headroom - tipRoom;
    var pad = elH < free ? Math.round((free - elH) / 2) : 0;
    var max = Math.max(0, docH - vh);
    return Math.max(0, Math.min(max, Math.round(absTop - headroom - pad)));
  }

  /* -1 means the tour is over. Back from the first stop stays on the first. */
  function nextIndex(i, total, dir) {
    var n = i + dir;
    if (n < 0) return 0;
    if (n >= total) return -1;
    return n;
  }

  function tourCardHTML(stop) {
    var h = '<div class="sp-n">Step ' + stop.n + " of " + stop.of + "</div>";
    h += '<b class="sp-t" id="hd-spot-title">' + esc(stop.title) + "</b>";
    h += '<p class="sp-b">' + esc(stop.body) + "</p>";
    h += '<div class="sp-foot">';
    h += '<button type="button" class="sp-btn" data-spot="back"' + (stop.n === 1 ? " disabled" : "") + ">Back</button>";
    h += '<button type="button" class="sp-btn pri" data-spot="next">' + (stop.n === stop.of ? "Done" : "Next") + "</button>";
    h += '<button type="button" class="sp-btn skip" data-spot="skip">Skip tour</button>';
    h += "</div>";
    return h;
  }

  /* v9: where the tour overlay is mounted, and why it is not <body>.

     layout/app.liquid hides every direct child of <body> that is not the app
     shell:

       body > *:not(.hap-root):not(script):not(noscript):not(style)
              :not(link):not(template):not([id^="shopify-pc"])
              :not([class^="shopify-pc"]) { display: none !important }

     which is how the app layout keeps injected third party app blocks out of a
     full screen surface. The tour appended itself straight to <body>, so on the
     live site it built every step and then computed to display:none. It rendered
     perfectly in the local harness, which has no such rule, which is why this
     survived to production.

     The fix is to mount inside the shell instead: walk up from the dashboard root
     to the element that is itself a child of <body>. On the app layout that is
     .hap-root; on a plain theme page it is the section wrapper, which the rule
     does not apply to anyway.

     The one thing that can go wrong with moving a position:fixed element down the
     tree is an ancestor that creates a containing block for it: a transform,
     perspective, filter, backdrop-filter, a will-change naming one of those, or
     contain with paint/layout/strict/content. Any of those would re-base the
     overlay onto that element and the viewport arithmetic in paint() would be
     measuring the wrong box. overflow does not matter: a fixed element is not
     clipped by an ancestor's overflow unless that ancestor is its containing
     block. So candidates are tried in order and the first one that actually
     measures as a viewport sized box wins, with <body> kept as the last resort so
     any layout without the rule behaves exactly as it did before. */
  function spotHostCandidates(rootEl, doc) {
    var out = [];
    var body = doc && doc.body;
    if (!body) return out;
    if (rootEl) {
      var n = rootEl;
      while (n && n.parentNode && n.parentNode !== body) n = n.parentNode;
      if (n && n.parentNode === body) out.push(n);
      if (rootEl.closest) {
        var shell = null;
        try { shell = rootEl.closest(".hap-root"); } catch (_) { shell = null; }
        if (shell && out.indexOf(shell) === -1) out.push(shell);
      }
    }
    if (out.indexOf(body) === -1) out.push(body);
    return out;
  }

  /* A mount is good when the overlay, which is position:fixed inset:0, really did
     come out the size of the viewport. display:none gives 0 by 0, and a re-based
     fixed element gives the host's box instead. 2px of slack for subpixel widths
     and for a scrollbar-less viewport rounding. */
  function spotMountOK(rect, vw, vh) {
    if (!rect) return false;
    if (rect.width < 1 || rect.height < 1) return false;
    return Math.abs(rect.width - vw) <= 2 && Math.abs(rect.height - vh) <= 2 &&
      Math.abs(rect.left) <= 2 && Math.abs(rect.top) <= 2;
  }

  function spotOverlayHTML() {
    var h = '<div class="hdspot" id="hd-spot" hidden>';
    h += '<svg class="sp-svg" id="hd-spot-svg" aria-hidden="true"><defs><mask id="hd-spot-hole">' +
      '<rect id="hd-spot-all" x="0" y="0" width="100%" height="100%" fill="#fff"></rect>' +
      '<rect id="hd-spot-cut" x="0" y="0" width="0" height="0" rx="16" ry="16" fill="#000"></rect>' +
      '</mask></defs>' +
      '<rect class="sp-dim" id="hd-spot-dim" x="0" y="0" width="100%" height="100%" mask="url(#hd-spot-hole)"></rect></svg>';
    h += '<div class="sp-ring" id="hd-spot-ring"></div>';
    h += '<div class="sp-tip" id="hd-spot-tip" role="dialog" aria-modal="true" aria-labelledby="hd-spot-title" tabindex="-1"></div>';
    h += "</div>";
    return h;
  }

  /* ===================== page renderers ===================== */
  /* ===================== v5: zero-state invitation page ===================== */
  function renderZero(model, firstName, demo, opts) {
    opts = opts || {};
    var h = "";

    /* photographic hero */
    h += '<div class="zhero">';
    h += '<div class="zhero-media"><img src="' + SCENES.hero + '" alt="" fetchpriority="high"><span class="zhero-scrim"></span></div>';
    h += '<div class="zhero-copy">';
    h += '<div class="eyebrow">Hewyn <span class="dot"></span> Health dashboard</div>';
    h += "<h1>" + (firstName ? esc(firstName) + ", let's map your health." : "Let's map your health.") + "</h1>";
    h += '<p class="lead">Ten tests, one dashboard, and a physician who reads all of it.</p>';
    h += '<a class="hd-pill" href="/pages/start">Find where to start</a>';
    h += '<div><a class="hd-ghostlink" href="/pages/diagnostics-preview">or browse all ten tests</a></div>';
    h += '<div><a class="hd-ghostlink" href="#" data-upload="">or upload results you already have</a></div>';
    if (opts.loggedOut) {
      h += '<span class="zlogin">Already a member? <a href="/account/login?return_url=' +
        esc(encodeURIComponent(opts.returnPath || "/pages/dashboard-preview")) + '">Log in</a></span>';
    }
    h += "</div></div>";

    /* what you'll see: a quiet, real preview of the dashboard itself */
    h += '<div class="sect">';
    h += '<div class="h2row"><span class="h2">What you\'ll see</span><span class="h2sub">a live look, not a mockup</span></div>';
    h += '<div class="zduo"><div class="zpeek">';
    h += '<div class="zpeek-head"><span>Good morning, Alex</span><span class="zpeek-tag">Physician reviewed</span></div>';
    h += '<div class="zpeek-rings">';
    /* the same four systems, at the same scores the sample dashboard actually
       renders for Alex. A preview that shows different numbers is a lie. */
    [["Heart", 78], ["Metabolic", 93], ["Nutrients", 64], ["Recovery", 70]].forEach(function (r) {
      h += '<span class="zring"><span class="rr">' + ringSVG(56, 24, 5, r[1], ringColor(r[1]), "rgba(255,255,255,.13)") +
        '<span class="c">' + r[1] + "</span></span><i>" + esc(r[0]) + "</i></span>";
    });
    h += "</div>";
    h += '<div class="zinsight"><b>Your vitamin D and your omega-3 are connected.</b>' +
      '<p>Both sit just under range, and both feed the same two systems. One change covers the pair.</p>' +
      '<p class="dim">Retest in twelve weeks and this card starts tracking the trend against the plan your physician reviewed.</p></div>';
    h += '<a class="hd-pill" href="?demo=1">See a sample dashboard</a>';
    h += "</div>";

    /* trust strip */
    h += '<div class="ztrust">' +
      "<div><b>Physician reviewed</b><span>every plan, every result</span></div>" +
      "<div><b>AI clearly labeled</b><span>never dressed up as a doctor</span></div>" +
      "<div><b>Results in days</b><span>3 to 5 for most tests</span></div>" +
      "</div></div></div>";

    /* v7: the loop, said out loud. This page is empty for exactly one reason
       and a first-time visitor deserves to be told it plainly, along with what
       arrives in its place once they have tested. */
    h += '<div class="sect">';
    h += '<div class="h2row"><span class="h2">How this works</span><span class="h2sub">three steps, on a loop</span></div>';
    h += '<p class="sectline">This page is empty because you haven\'t tested yet. Here\'s what fills it.</p>';
    h += '<div class="zloop">';
    [
      ["Measure", "Take a test, at home or at a partner center. Results come back in three to five days for most tests."],
      ["Understand", "Every result turns into a score for one part of your body. The findings get read together, and a physician checks the lot."],
      ["Act, then retest", "You get a routine you can accept or skip, and a projection of where it takes you. Retest and everything redraws."]
    ].forEach(function (s, i) {
      h += '<div class="zl"><span class="zln">' + (i + 1) + "</span><div><b>" + esc(s[0]) + "</b><p>" + esc(s[1]) + "</p></div></div>";
    });
    h += "</div>";

    /* the two ways in, side by side and equally weighted. Buying a test is not
       the only honest answer for someone who already has results in a drawer. */
    h += '<div class="zpaths">';
    h += '<a class="zpath" href="/pages/start"><span class="zpk">Path one</span>' +
      "<b>Answer a few questions</b><p>Ninety seconds. We ask what you want to change and what you've measured before, then name the one test to start with and tell you why.</p>" +
      '<span class="zpgo">Start the guided flow</span></a>';
    h += '<a class="zpath" href="#" data-upload=""><span class="zpk">Path two</span>' +
      "<b>Upload results you already have</b><p>A blood panel, a scan, a lab report from anywhere. Our physician team reads it in, usually within one to two business days, and this page fills in from there.</p>" +
      '<span class="zpgo">Upload a report</span></a>';
    h += "</div></div>";

    /* the ten tests as image-driven cards, each carrying who it is for */
    h += '<div class="sect">';
    h += '<div class="h2row"><span class="h2">Choose your way in</span><span class="h2sub">start anywhere, it all joins up</span></div>';
    h += '<p class="sectline">Every test looks at the same body from a different angle. Start with whichever one answers your loudest question. Each card says who it suits, and says so when it honestly isn\'t the place to start.</p>';
    h += '<div class="bento" style="padding:0">';
    model.tiles.forEach(function (t) { h += tileHTML(t, demo, opts.uploads, { who: true }); });
    h += "</div></div>";

    h += '<div class="strip dark"><span class="v">One test is a snapshot. Two or three start to show you movement, and the advice gets sharper with each one.</span></div>';
    return h;
  }

  /* The sticky action bar. Reports today's standing on the plan and carries the
     single primary action. Renders only when there is a routine to open, so it
     never promises a screen that is not there. */
  function dobarHTML(ai, routineState) {
    if (!ai || !ai.routine || !ai.routine.stacks || !ai.routine.stacks.length) return "";
    var active = 0, total = 0, waiting = 0;
    ai.routine.stacks.forEach(function (st) {
      var c = stackCounts(st, routineState || {});
      active += c.active; total += c.total;
      (st.actions || []).forEach(function (a) { if (actionStatus(a, routineState || {}) === "proposed") waiting++; });
    });
    if (!total) return "";
    /* "active" means not rejected, which is the same word the stack cards use.
       Saying "kept" here would claim an acceptance the customer never gave. */
    var line = waiting ? waiting + " actions waiting on you" : active + " of " + total + " active";
    var h = '<div class="dobar-space"></div>';
    h += '<div class="dobar" id="hd-dobar"><div><span class="dk t-micro">Your routine</span>' +
      '<span class="dv">' + line + "</span></div>";
    h += '<a class="hd-pill" href="#hd-routine" data-dobar="">Open plan</a></div>';
    return h;
  }

  function renderDash(model, firstName, demo, opts) {
    opts = opts || {};
    var hour = typeof opts.hour === "number" ? opts.hour : 12;
    var routineState = opts.routineState || {};

    /* v5: the zero state is its own invitation page */
    if (model.mode === "empty") {
      var hz = '<div class="hd-shell zero">';
      hz += renderZero(model, firstName, demo, opts);
      hz += uploadSheetHTML({ email: opts.authEmail || "" });
      hz += '<div class="footer-space"></div></div>';
      return hz;
    }

    /* v5: ready and processing tiles first, add cards under their own header */
    var mainTiles = [], addTiles = [];
    model.tiles.forEach(function (t) { (t.state === "add" ? addTiles : mainTiles).push(t); });

    var h = '<div class="hd-shell">';
    h += renderHero(model, firstName, demo, hour);
    /* v6: the guided welcome sits directly under the greeting, in its own slot.
       Open on a first visit, collapsed to a single replay link after that. It
       lives outside the hero so the hero still resolves inside a 667px frame. */
    h += tourHTML(firstName, demo, opts.tourOpen !== false);

    h += renderRings(model.ai, demo);
    h += renderInsights(model.ai, demo);
    h += renderRoutine(model.ai, routineState);
    h += renderNextSteps(model.ai);
    if (!model.ai.nextSteps && !demo) {
      h += '<div class="strip"><span class="k">Next up</span><span class="v">' + esc(model.nextUp) + "</span></div>";
    }

    /* v6: the tests grid gets a heading and a line of guidance like every other
       section, and the id the welcome step 3 points at. */
    if (mainTiles.length) {
      h += '<div class="sect" id="hd-tests">';
      /* v8: "N of M tests in" describes this section, so it lives here */
      var lin = model.hero.lensesIn, ltot = model.hero.lensesTotal, cov = "";
      for (var ci = 0; lin < ltot && ci < ltot; ci++) cov += '<span class="pip' + (ci < lin ? " on" : "") + '"></span>';
      if (cov) cov = '<span class="pips">' + cov + "</span>";
      h += '<div class="h2row"><span class="h2">Your tests</span><span class="h2sub cov">' + cov +
        "<span>" + lin + " of " + ltot + " tests in</span></span></div>";
      h += '<p class="secthint">Every result you\'ve got, with its headline number. Tap one to open the full report.</p>';
      h += '<div class="bento" style="padding:0">';
      mainTiles.forEach(function (t) { h += tileHTML(t, demo, opts.uploads); });
      h += "</div></div>";
    }

    if (addTiles.length) {
      h += '<div class="sect"' + (mainTiles.length ? "" : ' id="hd-tests"') + ">";
      h += '<div class="h2row"><span class="h2">Fill in the rest.</span><span class="h2sub">' + addTiles.length + " test" + (addTiles.length > 1 ? "s" : "") + " to go</span></div>";
      h += '<p class="sectline">Each test you add sharpens every insight above.</p>';
      h += '<div class="bento" style="padding:0">';
      addTiles.forEach(function (t) { h += tileHTML(t, demo, opts.uploads); });
      h += "</div></div>";
    }

    h += '<div class="strip dark"><span class="v">One test is a snapshot. Two or three start to show you movement, and the advice gets sharper with each one.</span></div>';
    if (model.ai.has) {
      h += '<p class="ai-note">AI sections are informational, not medical advice. Your physician reviews every plan and remains the authority. Speak to your physician before changing any medication.</p>';
    }
    h += '<div class="footer-space"></div>';

    /* ===== the sticky action bar (direction C) =====
       The one filled action on the screen, and the reason the first screen can
       carry the next step no matter what sits under the hero. It is fixed, so
       it adds no height to the flow and cannot move anything the frame-holding
       logic measures; the spacer below reserves the room it covers at the end
       of the page. Glass here and on nothing else in this file. */
    h += dobarHTML(model.ai, routineState);

    /* v3: blood marker browser overlay (rendered once, toggled open) */
    var bloodTile = null;
    model.tiles.forEach(function (t) { if (t.key === "blood" && t.state === "ready") bloodTile = t; });
    if (bloodTile && bloodTile.data && isArr(bloodTile.data.findings) && bloodTile.data.findings.length) {
      var bd = lensDate("blood", bloodTile.data);
      h += bloodBrowserHTML(bloodTile.data.findings, bd ? fmtD(bd) : null);
    }
    /* v4: upload sheet overlay (rendered once, opened from tiles or the empty hero) */
    h += uploadSheetHTML({ email: opts.authEmail || "" });
    h += "</div>";
    return h;
  }

  /* ===================== demo detection ===================== */
  /* Robust across the /en-ae/ locale redirect and internal navigation:
     ?demo=1 or #demo turns it on and persists to sessionStorage for this tab;
     ?demo=0 turns it off and clears the flag. Demo wins over a logged-in
     customer so the sample dashboard is always reachable for walkthroughs. */
  var DEMO_SS_KEY = "hewyn_demo";
  function detectDemo(loc, ss) {
    var search = String((loc && loc.search) || "");
    var hash = String((loc && loc.hash) || "");
    if (/(?:\?|&)demo=0(?:&|$)/.test(search)) {
      if (ss) { try { ss.removeItem(DEMO_SS_KEY); } catch (_) {} }
      return false;
    }
    var on = /(?:\?|&)demo=1(?:&|$)/.test(search) || /^#demo(?:=1)?$/.test(hash);
    if (on) {
      if (ss) { try { ss.setItem(DEMO_SS_KEY, "1"); } catch (_) {} }
      return true;
    }
    try { return !!(ss && ss.getItem(DEMO_SS_KEY) === "1"); } catch (_) { return false; }
  }

  /* ===================== v6: frame stability primitives =====================
     Every complaint about "the frame moves when I click" on this page came from
     the same shape of bug: a disclosure changes the height of a block, and the
     browser then decides for itself what to do with the scroll position. Chrome
     guesses an anchor, Safari does nothing at all, so the same tap behaved
     differently on the two engines. Native anchoring is off in the CSS and the
     decision is made here instead, explicitly, against the control the finger
     touched: measure its position in the frame, mutate, put it back. */
  function scrollerOf(el) {
    var doc = (typeof document !== "undefined" && (document.scrollingElement || document.documentElement)) || null;
    var n = el && el.parentNode;
    while (n && n.nodeType === 1) {
      var st = null;
      try { st = window.getComputedStyle(n); } catch (_) { st = null; }
      if (st) {
        var oy = st.overflowY;
        if ((oy === "auto" || oy === "scroll") && n.scrollHeight > n.clientHeight + 1) return n;
      }
      n = n.parentNode;
    }
    return doc;
  }
  /* getAnchor may be a node or a function returning one, because some mutations
     (the welcome panel) replace the anchor node itself. */
  function holdFrame(getAnchor, mutate) {
    var a0 = typeof getAnchor === "function" ? getAnchor() : getAnchor;
    var top0 = a0 && a0.getBoundingClientRect ? a0.getBoundingClientRect().top : null;
    var scroller = a0 ? scrollerOf(a0) : null;
    mutate();
    if (top0 == null || !scroller) return 0;
    var a1 = typeof getAnchor === "function" ? getAnchor() : a0;
    if (!a1 || !a1.getBoundingClientRect) return 0;
    var d = a1.getBoundingClientRect().top - top0;
    if (Math.abs(d) > 0.5) scroller.scrollTop += d;
    return d;
  }
  /* A panel that opens entirely below the fold reads as "nothing happened", and
     the fix for that is not to let the page jump on its own but to move it once,
     smoothly, and only when the panel really is out of sight. The bar is
     deliberately low: a panel with a usable strip already in the frame is left
     exactly where it is, because a helpful scroll and an unwanted lurch feel
     identical from the reader's side. */
  var FRAME_HEADROOM = 96;
  var FRAME_ENOUGH = 140;
  function ensureInFrame(anchor, panel) {
    if (!anchor || !panel || !panel.getBoundingClientRect) return false;
    var doc = document.scrollingElement || document.documentElement;
    if (scrollerOf(anchor) !== doc) return false;
    var vh = window.innerHeight || 0;
    var pr = panel.getBoundingClientRect();
    if (!pr.height || !vh) return false;
    var visible = Math.max(0, Math.min(pr.bottom, vh) - Math.max(pr.top, 0));
    if (visible >= Math.min(pr.height, FRAME_ENOUGH)) return false;
    var top = doc.scrollTop + anchor.getBoundingClientRect().top - FRAME_HEADROOM;
    if (top < 0) top = 0;
    try { window.scrollTo({ top: top, behavior: "smooth" }); }
    catch (_) { doc.scrollTop = top; }
    return true;
  }

  /* ===================== boot ===================== */
  var API = {
    compute: compute, statusOf: statusOf, lensCounts: lensCounts, computeRings: computeRings,
    computeRecoveryRing: computeRecoveryRing, sleepHoursOf: sleepHoursOf,
    scoreLabel: scoreLabel, renderDash: renderDash, tileHTML: tileHTML,
    loadRoutineState: loadRoutineState, saveRoutineState: saveRoutineState,
    setActionStatus: setActionStatus, actionStatus: actionStatus,
    stackCounts: stackCounts, improvesList: improvesList, detectDemo: detectDemo,
    /* v3 */
    markerIndex: markerIndex, findMarker: findMarker, systemsOfMarker: systemsOfMarker,
    MARKER_ALIASES: MARKER_ALIASES, MARKER_GROUPS: MARKER_GROUPS, analyteOf: analyteOf,
    markerIs: markerIs, categoryOf: categoryOf, isRecoveryBloodMarker: isRecoveryBloodMarker,
    ringContributors: ringContributors, barPos: barPos, ringPanelHTML: ringPanelHTML,
    impactOf: impactOf, buildCareActions: buildCareActions, computeOutlook: computeOutlook,
    insightSlots: insightSlots, insightMarkers: insightMarkers, insightSystems: insightSystems,
    insightCardHTML: insightCardHTML, planInnerHTML: planInnerHTML,
    bloodBrowserModel: bloodBrowserModel, bloodBrowserHTML: bloodBrowserHTML,
    /* v4 upload */
    uploadSheetHTML: uploadSheetHTML, validateUpload: validateUpload,
    loadUploads: loadUploads, saveUpload: saveUpload, uploadLensName: uploadLensName,
    /* wave 1: glossary + visualization */
    lensName: lensName, lensReportHref: lensReportHref,
    bandGeom: bandGeom, bandZoneText: bandZoneText, cbarHTML: cbarHTML,
    sparkHTML: sparkHTML, tileSpark: tileSpark,
    /* v6: welcome + frame stability */
    TOUR_KEY: TOUR_KEY, loadTour: loadTour, saveTour: saveTour,
    tourHTML: tourHTML,
    /* v7: spotlight tour + zero-state fit copy */
    tourStops: tourStops, resolveStops: resolveStops, canRunTour: canRunTour, tourRoute: tourRoute,
    spotRect: spotRect, placeTip: placeTip, scrollTopFor: scrollTopFor, nextIndex: nextIndex,
    spotHostCandidates: spotHostCandidates, spotMountOK: spotMountOK,
    tourCardHTML: tourCardHTML, spotOverlayHTML: spotOverlayHTML,
    WHO: WHO, whoHTML: whoHTML,
    scrollerOf: scrollerOf, holdFrame: holdFrame, ensureInFrame: ensureInFrame,
    /* v5 */
    renderZero: renderZero, testHref: testHref, SCENES: SCENES,
    UPLOAD_KEY: UPLOAD_KEY, UPLOAD_ENDPOINT: UPLOAD_ENDPOINT, UPLOAD_MAX_BYTES: UPLOAD_MAX_BYTES,
    LENSES: LENSES, DEMO_DATA: DEMO_DATA, DEMO_NAME: DEMO_NAME, ROUTINE_KEY: ROUTINE_KEY
  };

  function boot() {
    var root = document.getElementById("hd-root");
    if (!root) return;
    var raw = null;
    try {
      var el = document.getElementById("hd-data");
      raw = el ? JSON.parse(el.textContent) : null;
    } catch (_) { raw = null; }
    var auth = root.getAttribute("data-auth") === "1";
    var firstName = root.getAttribute("data-first-name") || "";
    var authEmail = root.getAttribute("data-email") || "";
    var customerId = root.getAttribute("data-customer-id") || "";
    var session = null;
    try { session = window.sessionStorage; } catch (_) { session = null; }
    var isDemo = detectDemo(window.location, session);

    var storage;
    try { storage = window.localStorage; } catch (_) { storage = { getItem: function(){return null;}, setItem: function(){} }; }
    var routineState = loadRoutineState(storage);
    var uploads = loadUploads(storage);
    var tour = loadTour(storage);
    var hour = new Date().getHours();
    var renderOpts = {
      hour: hour, routineState: routineState, uploads: uploads, authEmail: authEmail,
      /* first visit, or a value we could not read, means show it */
      tourOpen: !tour.dismissed
    };

    /* demo wins over auth: a logged-in teammate opening ?demo=1 must see the
       full sample dashboard, not their own partial data. ?demo=0 exits. */
    var model, demo = false, name = firstName;
    if (isDemo) {
      model = compute(DEMO_DATA, { demo: true, routineState: routineState });
      demo = true; name = DEMO_NAME;
    } else if (auth) {
      model = compute(raw || {}, { routineState: routineState });
    } else {
      /* v5: logged-out visitors get the same zero-state invitation page,
         with a quiet log in link in the hero instead of a bare login wall */
      model = compute({}, {});
      name = "";
      renderOpts.loggedOut = true;
      renderOpts.returnPath = window.location.pathname;
    }

    root.classList.add("pre");
    root.innerHTML = renderDash(model, name, demo, renderOpts);
    /* animate rings in (CSS transition, gated by prefers-reduced-motion) */
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove("pre"); }); });

    /* ===== v6: reserve the projection's tallest state =====
       Accepting or rejecting an action re-renders the bars in place, and a
       shorter render used to drag the rest of the page up behind it. An action
       counts towards the projection unless it is rejected, so the render with
       nothing rejected is the tallest this block can ever be. Measure that once,
       off-screen, and hold it as a floor. Nothing is clipped and the default
       state fills the reserved box exactly, so there is no dead space. */
    var planFloor = 0;
    function measurePlanFloor() {
      var host = root.querySelector("#hd-plan");
      if (!host || !model.ai || !model.ai.routine) return;
      var tallest = compute(demo ? DEMO_DATA : (raw || {}), { demo: demo, routineState: {} });
      var ghost = document.createElement("div");
      ghost.className = "plansect";
      ghost.setAttribute("aria-hidden", "true");
      ghost.style.cssText = "position:absolute;left:-10000px;top:0;visibility:hidden;pointer-events:none;width:" +
        (host.offsetWidth || 0) + "px";
      ghost.innerHTML = planInnerHTML(tallest.ai);
      host.parentNode.appendChild(ghost);
      planFloor = Math.ceil(ghost.getBoundingClientRect().height);
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      host.style.minHeight = planFloor ? planFloor + "px" : "";
    }
    requestAnimationFrame(function () { requestAnimationFrame(measurePlanFloor); });
    var reflowT = null;
    window.addEventListener("resize", function () {
      if (reflowT) clearTimeout(reflowT);
      reflowT = setTimeout(function () {
        var host = root.querySelector("#hd-plan");
        if (host) host.style.minHeight = "";
        measurePlanFloor();
      }, 220);
    });

    /* ===== v6: the welcome panel, opened and dismissed in place ===== */
    function setTour(open, byHand) {
      var bar = root.querySelector("#hd-tour");
      if (!bar) return;
      holdFrame(function () { return root.querySelector("#hd-tour"); }, function () {
        bar.outerHTML = tourHTML(name, demo, open);
      });
      tour = saveTour(storage, !open);
      /* focus on open by hand, back on close, never on first paint */
      var f = byHand && root.querySelector(open ? ".tour-sheet" : "[data-tour-open]");
      if (f && f.focus) { try { f.focus(); } catch (_) {} }
    }

    document.addEventListener("keydown", function (ev) {
      if (ev.key !== "Escape" && ev.keyCode !== 27) return;
      if (spot && spot.on) return;
      if (root.querySelector(".tour-ov")) { ev.preventDefault(); setTour(false, true); }
    });

    /* ===== v7: the spotlight tour =====
       The whole of the scroll-then-highlight problem lives in start(): the card
       and the ring are hidden, the page is scrolled to the stop, the scroll is
       watched until it has actually stopped moving, and only then is the cutout
       measured and drawn. Nothing is ever drawn at one place and moved to
       another, which is the thing that makes a home made coach mark feel broken.
       Recomputed on resize, on scroll and whenever the target changes size. */
    var reduced = false;
    try { reduced = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (_) { reduced = false; }

    var spot = {
      on: false, stops: [], i: 0, trigger: null, ov: null,
      ro: null, raf: null, hosts: null, hostI: 0
    };

    function spotEl(id) { return document.getElementById(id); }

    function ensureOverlay() {
      if (spot.ov && spot.ov.parentNode) return spot.ov;
      var host = document.createElement("div");
      host.innerHTML = spotOverlayHTML();
      spot.ov = host.firstChild;
      spot.hosts = spotHostCandidates(root, document);
      spot.hostI = 0;
      (spot.hosts[0] || document.body).appendChild(spot.ov);
      return spot.ov;
    }

    /* Called once the overlay is visible. If this mount did not give a viewport
       sized box, the next candidate is tried. Nothing has been painted yet at
       this point, so a remount is invisible. */
    function verifyMount() {
      if (!spot.ov) return;
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var hosts = spot.hosts || [document.body];
      for (var guard = 0; guard < hosts.length; guard++) {
        var r = null;
        try { r = spot.ov.getBoundingClientRect(); } catch (_) { r = null; }
        if (spotMountOK(r, vw, vh)) return;
        if (spot.hostI + 1 >= hosts.length) return;
        spot.hostI++;
        hosts[spot.hostI].appendChild(spot.ov);
      }
    }

    /* the one place that measures. Called after a scroll has settled, and again
       on every resize, scroll or target resize while the tour is open. */
    function paint() {
      if (!spot.on) return;
      var stop = spot.stops[spot.i];
      if (!stop || !stop.el || !stop.el.getBoundingClientRect) { closeSpot(true); return; }
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = stop.el.getBoundingClientRect();
      var tipEl = spotEl("hd-spot-tip");
      var tipH = tipEl ? Math.round(tipEl.getBoundingClientRect().height) || 200 : 200;
      var sr = spotRect({ left: r.left, top: r.top, width: r.width, height: r.height }, stop.pad, vw, vh,
        Math.max(160, vh - 84 - tipH - 34));
      /* the cutout follows the element's own corner radius, so a pill stays a
         pill and a 18px card stays an 18px card */
      var rad = 16;
      try {
        var cs = window.getComputedStyle(stop.el);
        var pr = parseFloat(cs.borderTopLeftRadius);
        if (!isNaN(pr)) rad = Math.min(28, Math.max(0, pr) + (stop.pad || 0));
      } catch (_) {}
      var cut = spotEl("hd-spot-cut");
      if (cut) {
        cut.setAttribute("x", sr.x); cut.setAttribute("y", sr.y);
        cut.setAttribute("width", sr.w); cut.setAttribute("height", sr.h);
        cut.setAttribute("rx", rad); cut.setAttribute("ry", rad);
      }
      var ring = spotEl("hd-spot-ring");
      if (ring) {
        ring.style.left = sr.x + "px"; ring.style.top = sr.y + "px";
        ring.style.width = sr.w + "px"; ring.style.height = sr.h + "px";
        ring.style.borderRadius = rad + "px";
      }
      var tip = tipEl;
      if (tip) {
        var tr = tip.getBoundingClientRect();
        var p = placeTip(sr, Math.round(tr.width) || 330, tipH, vw, vh);
        tip.style.left = p.x + "px";
        tip.style.top = p.y + "px";
        tip.setAttribute("data-place", p.place);
        tip.style.setProperty("--sp-ax", p.ax + "px");
      }
    }

    function schedulePaint() {
      if (spot.raf) return;
      spot.raf = window.requestAnimationFrame(function () { spot.raf = null; paint(); });
    }

    /* wait until the scroll has genuinely stopped, rather than guessing at a
       duration. Three still frames, or 1.2s, whichever comes first. */
    function settle(cb) {
      var last = null, still = 0, t0 = Date.now();
      (function loop() {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (last !== null && Math.abs(y - last) < 0.5) still++; else still = 0;
        last = y;
        if (still >= 3 || Date.now() - t0 > 1200) { cb(); return; }
        window.requestAnimationFrame(loop);
      })();
    }

    function focusables(el) {
      return Array.prototype.slice.call(el.querySelectorAll("button:not([disabled])"));
    }

    function showStop(i) {
      spot.i = i;
      var stop = spot.stops[i];
      var ov = ensureOverlay();
      var tip = spotEl("hd-spot-tip");
      /* hide while we move: the card must never be seen pointing at the wrong
         thing, and with reduced motion it simply appears in the right place */
      ov.classList.add("sp-moving");
      if (tip) tip.innerHTML = tourCardHTML(stop);
      var doc = document.scrollingElement || document.documentElement;
      var r = stop.el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var top = scrollTopFor(r.top + doc.scrollTop, r.height, vh, doc.scrollHeight, 84, 200);
      if (Math.abs(top - doc.scrollTop) > 1) {
        try { window.scrollTo({ top: top, behavior: reduced ? "auto" : "smooth" }); }
        catch (_) { window.scrollTo(0, top); }
      }
      settle(function () {
        if (!spot.on) return;
        paint();
        ov.classList.remove("sp-moving");
        watchTarget(stop.el);
        var f = tip ? focusables(tip) : [];
        var want = null;
        for (var k = 0; k < f.length; k++) if (f[k].getAttribute("data-spot") === "next") want = f[k];
        if (want) want.focus();
        else if (tip) tip.focus();
      });
    }

    function watchTarget(el) {
      if (spot.ro) { try { spot.ro.disconnect(); } catch (_) {} spot.ro = null; }
      if (typeof window.ResizeObserver !== "function") return;
      try {
        spot.ro = new window.ResizeObserver(schedulePaint);
        spot.ro.observe(el);
      } catch (_) { spot.ro = null; }
    }

    function openSpot(trigger) {
      var stops = resolveStops(tourStops(), function (sel) { return root.querySelector(sel) || document.querySelector(sel); });
      if (!canRunTour(stops)) { setTour(true, true); return false; }
      spot.stops = stops;
      spot.trigger = trigger || null;
      spot.on = true;
      var ov = ensureOverlay();
      ov.hidden = false;
      verifyMount();
      document.addEventListener("keydown", onSpotKey, true);
      window.addEventListener("resize", schedulePaint);
      window.addEventListener("scroll", schedulePaint, true);
      showStop(0);
      return true;
    }

    function closeSpot(done) {
      if (!spot.on) return;
      spot.on = false;
      if (spot.ro) { try { spot.ro.disconnect(); } catch (_) {} spot.ro = null; }
      document.removeEventListener("keydown", onSpotKey, true);
      window.removeEventListener("resize", schedulePaint);
      window.removeEventListener("scroll", schedulePaint, true);
      if (spot.ov) spot.ov.hidden = true;
      /* seeing the tour counts as having been shown the page, however it ended */
      tour = saveTour(storage, true);
      var bar = root.querySelector("#hd-tour");
      if (bar && bar.querySelector("#hd-tourpanel")) setTour(false);
      /* focus goes back where it came from, or to the replay link if the panel
         that held the trigger has since been collapsed away */
      var back = spot.trigger && spot.trigger.isConnected ? spot.trigger : root.querySelector("[data-tour-open]");
      if (back && back.focus) { try { back.focus(); } catch (_) {} }
      spot.trigger = null;
      return done;
    }

    function stepSpot(dir) {
      var n = nextIndex(spot.i, spot.stops.length, dir);
      if (n < 0) { closeSpot(true); return; }
      showStop(n);
    }

    function onSpotKey(ev) {
      if (!spot.on) return;
      var k = ev.key;
      if (k === "Escape") { ev.preventDefault(); closeSpot(false); return; }
      if (k === "ArrowRight" || k === "ArrowDown") { ev.preventDefault(); stepSpot(1); return; }
      if (k === "ArrowLeft" || k === "ArrowUp") { ev.preventDefault(); stepSpot(-1); return; }
      if (k !== "Tab") return;
      /* focus stays inside the card while the tour owns the screen */
      var tip = spotEl("hd-spot-tip");
      if (!tip) return;
      var f = focusables(tip);
      if (!f.length) { ev.preventDefault(); tip.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (!tip.contains(document.activeElement)) { ev.preventDefault(); first.focus(); return; }
      if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
    }

    document.addEventListener("click", function (ev) {
      if (!spot.on) return;
      var t = ev.target;
      var btn = t && t.closest ? t.closest("[data-spot]") : null;
      if (btn) {
        ev.preventDefault();
        var a = btn.getAttribute("data-spot");
        if (a === "next") stepSpot(1);
        else if (a === "back") stepSpot(-1);
        else closeSpot(false);
        return;
      }
      /* a tap on the dim itself leaves. A tap inside the card does not. */
      if (spot.ov && spot.ov.contains(t)) {
        var tip = spotEl("hd-spot-tip");
        if (!tip || !tip.contains(t)) { ev.preventDefault(); closeSpot(false); }
      }
    }, true);

    /* ===== v4: upload sheet wiring ===== */
    var upLens = "";   /* current lens key; "" means the dropdown chooses */
    var upBusy = false;

    function upEl(sel) { return root.querySelector(sel); }
    function setUploadStatus(msg, cls) {
      var st = upEl("#hd-up-status");
      if (!st) return;
      st.textContent = msg || "";
      st.className = "up-status" + (cls ? " " + cls : "");
    }
    function refreshUploadSubmit() {
      var btn = upEl("#hd-up-submit"), ck = upEl("#hd-up-consent");
      if (btn) btn.disabled = upBusy || !(ck && ck.checked);
    }
    function openUpload(lensKey) {
      var ov = upEl("#hd-up");
      if (!ov) return;
      upLens = lensKey || "";
      var name = upLens && upLens !== "other" ? uploadLensName(upLens) : null;
      var title = upEl("#hd-up-title");
      if (title) title.textContent = name ? "Upload your " + name + " results" : "Upload your results";
      var lw = upEl("#hd-up-lenswrap");
      if (lw) lw.style.display = upLens ? "none" : "";
      var sel = upEl("#hd-up-lens");
      if (sel) sel.value = "";
      var fi = upEl("#hd-up-file");
      if (fi) fi.value = "";
      var ck = upEl("#hd-up-consent");
      if (ck) ck.checked = false;
      var btn = upEl("#hd-up-submit");
      if (btn) { btn.style.display = ""; btn.textContent = "Send for review"; }
      upBusy = false;
      setUploadStatus("", "");
      refreshUploadSubmit();
      openSheet(ov);
    }
    function markTileUploaded(lens) {
      var link = root.querySelector('.tile.add[data-lens="' + lens + '"] .upl-or');
      if (link) link.outerHTML = '<span class="upchip">Upload in review</span>';
    }
    function submitUpload() {
      if (upBusy) return;
      var sel = upEl("#hd-up-lens");
      var lens = upLens || (sel ? sel.value : "");
      var fi = upEl("#hd-up-file");
      var file = fi && fi.files && fi.files[0] ? fi.files[0] : null;
      var em = upEl("#hd-up-email");
      var email = String(authEmail || (em ? em.value : "") || "").trim();
      var ck = upEl("#hd-up-consent");
      /* demo stub first: nothing is ever sent from the sample dashboard */
      if (demo) { setUploadStatus("Demo mode, uploads are disabled.", "note"); return; }
      var v = validateUpload({ lens: lens, fileName: file ? file.name : "", fileSize: file ? file.size : null, email: email, consent: !!(ck && ck.checked) });
      if (!v.ok) { setUploadStatus(v.msg, "err"); return; }
      var btn = upEl("#hd-up-submit");
      upBusy = true;
      if (btn) btn.disabled = true;
      setUploadStatus("Uploading your report. This can take a few seconds, keep this page open.", "note");
      var fd = new FormData();
      fd.append("file", file);
      fd.append("lens", lens);
      fd.append("email", email);
      if (customerId) fd.append("customerId", customerId);
      fd.append("consent", "true");
      function fail() {
        upBusy = false;
        refreshUploadSubmit();
        setUploadStatus("That didn't go through. Nothing to fix on your side, just try again in a moment.", "err");
      }
      fetch(UPLOAD_ENDPOINT, { method: "POST", body: fd })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (body) {
            if (!res.ok || !body || body.ok !== true) { fail(); return; }
            uploads = saveUpload(storage, uploads, lens);
            markTileUploaded(lens);
            if (btn) btn.style.display = "none";
            setUploadStatus("Received. Your results appear here after our physician team reviews them, usually 1 to 2 business days.", "ok");
          });
        })
        .catch(fail);
    }

    root.addEventListener("change", function (ev) {
      if (ev.target && ev.target.id === "hd-up-consent") refreshUploadSubmit();
    });

    var openStack = null;

    /* ===== v6: bottom sheets leave the page alone =====
       The sheet is fixed, so opening it never moved the page by itself. What did
       move the page was a flick inside the sheet's list chaining through to the
       document behind it, so you came back to somewhere you had not chosen. The
       list now contains its own overscroll (see .bb-scroll), which fixes that at
       the source. Nothing here writes to the page's scroll position: forcing it
       back to where the sheet was opened turned out to be its own lurch, and a
       scroll the reader did not ask for is the thing being fixed. */
    var sheetReturn = null;
    function openSheet(ov) {
      var doc = document.scrollingElement || document.documentElement;
      sheetReturn = doc.scrollTop;
      var sc = ov.querySelector(".bb-scroll");
      if (sc) sc.scrollTop = 0;
      ov.classList.add("open");
    }
    function closeSheet(ov) {
      ov.classList.remove("open");
      sheetReturn = null;
    }

    function refreshRoutineDOM() {
      /* update counts + plan projection in place (no full re-render) */
      if (!model.ai.routine) return;
      model = compute(demo ? DEMO_DATA : (raw || {}), { demo: demo, routineState: routineState });
      model.ai.routine.stacks.forEach(function (st) {
        var elc = root.querySelector('[data-stack-count="' + st.id + '"]');
        if (elc) elc.textContent = stackCountText(st);
      });
      /* v3: the projection bars recompute on every toggle (the bridge) */
      var plan = root.querySelector("#hd-plan");
      if (plan) plan.innerHTML = planInnerHTML(model.ai);
    }

    root.addEventListener("click", function (ev) {
      var t = ev.target;

      /* v7: How this page works now starts the interactive tour. Reduced motion
         and any page the tour cannot walk fall back to the static explainer,
         which carries its own button into the tour for anyone who wants it. */
      var tOpen = t && t.closest ? t.closest("[data-tour-open]") : null;
      if (tOpen) {
        ev.preventDefault();
        var stops = resolveStops(tourStops(), function (sel) { return root.querySelector(sel) || document.querySelector(sel); });
        if (tourRoute(canRunTour(stops), reduced) === "spotlight") openSpot(tOpen);
        else setTour(true, true);
        return;
      }
      var tRun = t && t.closest ? t.closest("[data-tour-run]") : null;
      /* v8: the welcome is a modal now, so it yields to the spotlight rather
         than sitting over the page the spotlight is trying to point at. */
      if (tRun) { ev.preventDefault(); setTour(false); openSpot(root.querySelector("[data-tour-open]")); return; }
      var tDone = t && t.closest ? t.closest("[data-tour-dismiss]") : null;
      if (tDone) { ev.preventDefault(); setTour(false, true); return; }

      /* v7: the zero state's fit reveal. Driven by hand, against the control the
         finger touched, for the same reason every other disclosure here is. */
      var wTog = t && t.closest ? t.closest("[data-who]") : null;
      if (wTog) {
        ev.preventDefault();
        var rest = root.querySelector("#hd-who-" + wTog.getAttribute("data-who"));
        if (rest) {
          var willOpen = !!rest.hidden;
          holdFrame(wTog, function () {
            rest.hidden = !willOpen;
            wTog.setAttribute("aria-expanded", willOpen ? "true" : "false");
            wTog.textContent = willOpen ? "Less on fit" : "More on fit";
          });
        }
        return;
      }

      /* v6: the tap-to-reveal definitions are native <details>, and a native
         toggle changes height without telling anyone. Driven by hand so the
         summary you tapped keeps its place in the frame. */
      var sum = t && t.closest ? t.closest(".hdef summary") : null;
      if (sum) {
        var det = sum.parentNode;
        ev.preventDefault();
        holdFrame(sum, function () { det.open = !det.open; });
        return;
      }

      /* v4: open the upload sheet (tile secondary line or empty-hero link) */
      var upOpen = t && t.closest ? t.closest("[data-upload]") : null;
      if (upOpen) { ev.preventDefault(); openUpload(upOpen.getAttribute("data-upload")); return; }

      /* v4: upload submit */
      if (t && t.closest && t.closest("#hd-up-submit")) { ev.preventDefault(); submitUpload(); return; }

      /* v4: taps inside the upload sheet form never fall through to tile logic */
      if (t && t.closest && t.closest("#hd-up .bb-sheet") && !t.closest("[data-bb-close]")) return;

      /* dead-link tiles */
      var a = t && t.closest ? t.closest("a[data-state]") : null;
      if (a && a.getAttribute("href") === "#") ev.preventDefault();

      /* smooth-scroll internal anchors */
      var anchor = t && t.closest ? t.closest('a[href^="#hd-"]') : null;
      if (anchor) {
        var target = root.querySelector(anchor.getAttribute("href"));
        if (target) { ev.preventDefault(); target.scrollIntoView({ behavior: "smooth", block: "start" }); }
      }

      /* v3: blood marker browser open / close / category accordions */
      var bbOpen = t && t.closest ? t.closest("[data-bb]") : null;
      if (bbOpen) {
        ev.preventDefault();
        var ov = root.querySelector("#hd-bb");
        if (ov) openSheet(ov);
        return;
      }
      var bbClose = t && t.closest ? t.closest("[data-bb-close]") : null;
      var bbSheet = t && t.closest ? t.closest(".bb-sheet") : null;
      var bbOverlayEl = t && t.closest ? t.closest(".bb-overlay") : null;
      if (bbClose || (bbOverlayEl && !bbSheet)) {
        /* closes whichever bottom sheet the tap belongs to (markers or upload) */
        if (bbOverlayEl) closeSheet(bbOverlayEl);
        return;
      }
      var bbCat = t && t.closest ? t.closest(".bb-cat") : null;
      if (bbCat) {
        var ci = bbCat.getAttribute("data-bb-cat");
        var rowsEl = root.querySelector('[data-bb-rows="' + ci + '"]');
        var catOpen = bbCat.getAttribute("aria-expanded") === "true";
        /* the anchor is inside the sheet's own scroller, so holdFrame corrects
           that scroller rather than the page behind it */
        holdFrame(bbCat, function () {
          bbCat.setAttribute("aria-expanded", catOpen ? "false" : "true");
          if (rowsEl) rowsEl.classList.toggle("open", !catOpen);
        });
        return;
      }

      /* Wave 1: an AFFECTS system tag deep-links into that system's ring drill-down,
         rather than being an inert label. */
      var sysTag = t && t.closest ? t.closest("[data-sys-ring]") : null;
      if (sysTag) {
        ev.preventDefault();
        var wantSys = sysTag.getAttribute("data-sys-ring");
        var target = null;
        (model.ai.rings || []).forEach(function (r, i) { if (target === null && r && r.system === wantSys) target = i; });
        if (target !== null) {
          var btn = root.querySelector('.rcard[data-ring="' + target + '"]');
          var pbox = root.querySelector("#hd-rpanel");
          if (pbox) {
            pbox.innerHTML = ringPanelHTML(model.ai.rings[target], model.ai.index, demo);
            pbox.classList.add("open");
            pbox.scrollTop = 0;
            pbox.setAttribute("data-open", String(target));
          }
          root.querySelectorAll(".rcard").forEach(function (el) {
            el.setAttribute("aria-expanded", el === btn ? "true" : "false");
          });
          if (btn && btn.scrollIntoView) btn.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }

      /* v3: ring drill-down panel with contributor bars */
      var rc = t && t.closest ? t.closest(".rcard") : null;
      if (rc) {
        var idx = parseInt(rc.getAttribute("data-ring"), 10);
        var ring = model.ai.rings[idx];
        var box = root.querySelector("#hd-rpanel");
        if (box && ring) {
          var closing = box.getAttribute("data-open") === String(idx);
          /* the ring you tapped keeps its exact place in the frame while the
             panel below it opens, switches or closes */
          holdFrame(rc, function () {
            if (closing) {
              box.classList.remove("open"); box.removeAttribute("data-open");
            } else {
              box.innerHTML = ringPanelHTML(ring, model.ai.index, demo);
              box.classList.add("open");
              box.scrollTop = 0;
              box.setAttribute("data-open", String(idx));
            }
          });
          root.querySelectorAll(".rcard").forEach(function (el) {
            el.setAttribute("aria-expanded", (!closing && el === rc) ? "true" : "false");
          });
          if (!closing) ensureInFrame(rc, box);
        }
        return;
      }

      /* v3: insight overflow expander */
      var imore = t && t.closest ? t.closest("#hd-imore") : null;
      if (imore) {
        var ofl = root.querySelector("#hd-ioverflow");
        var isOpen = imore.getAttribute("aria-expanded") === "true";
        holdFrame(imore, function () {
          imore.setAttribute("aria-expanded", isOpen ? "false" : "true");
          imore.textContent = isOpen ? "View all insights (" + (model.ai.insightsMore ? model.ai.insightsMore.length : 0) + " more)" : "Show fewer insights";
          if (ofl) { ofl.classList.toggle("open", !isOpen); if (!isOpen) ofl.scrollTop = 0; }
        });
        if (!isOpen && ofl) ensureInFrame(imore, ofl);
        return;
      }

      /* v3: per-action steps expander */
      var sb = t && t.closest ? t.closest("[data-steps-btn]") : null;
      if (sb) {
        var sid = sb.getAttribute("data-steps-btn");
        var list = root.querySelector('[data-steps="' + sid + '"]');
        var sOpen = sb.getAttribute("aria-expanded") === "true";
        holdFrame(sb, function () {
          sb.setAttribute("aria-expanded", sOpen ? "false" : "true");
          if (list) list.classList.toggle("open", !sOpen);
        });
        return;
      }

      /* stack expand */
      var sc = t && t.closest ? t.closest(".stackcard") : null;
      if (sc) {
        var id = sc.getAttribute("data-stack");
        var was = openStack === id;
        var panel = root.querySelector('[data-actions="' + id + '"]');
        /* closing one stack and opening another changes the height of the block
           under the cards by hundreds of pixels; the card you tapped does not move */
        holdFrame(sc, function () {
          root.querySelectorAll(".stackcard").forEach(function (el) { el.setAttribute("aria-expanded", "false"); });
          root.querySelectorAll(".actions").forEach(function (el) { el.classList.remove("open"); });
          openStack = null;
          if (!was) {
            sc.setAttribute("aria-expanded", "true");
            if (panel) { panel.classList.add("open"); panel.scrollTop = 0; }
            openStack = id;
          }
        });
        if (!was && panel) ensureInFrame(sc, panel);
        return;
      }

      /* accept / reject toggle */
      var tb = t && t.closest ? t.closest(".tglbtn") : null;
      if (tb) {
        var aid = tb.getAttribute("data-action-id");
        var status = tb.getAttribute("data-toggle");
        routineState = setActionStatus(routineState, aid, status);
        saveRoutineState(storage, routineState);
        var row = tb.closest(".arow");
        /* the toggle stays under the finger while the counts and the projection
           below it recompute */
        holdFrame(tb, function () {
          if (row) {
            var now = routineState[aid] || "proposed";
            row.classList.toggle("rejected", now === "rejected");
            var yes = row.querySelector(".tglbtn.yes"), no = row.querySelector(".tglbtn.no");
            if (yes) yes.classList.toggle("on", now === "accepted");
            if (no) no.classList.toggle("on", now === "rejected");
          }
          refreshRoutineDOM();
        });
        return;
      }
    });

    /* v4: #upload deep link opens the sheet with the lens dropdown
       (also the way to reach it on the demo dashboard, where every tile is Ready) */
    if (/^#upload$/.test(String(window.location.hash || ""))) openUpload("");
  }

  try { window.__HD__ = API; } catch (_) {}
  if (typeof module !== "undefined" && module.exports) module.exports = API;

  if (typeof document !== "undefined") {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
    else boot();
  }
})();
